(() => {
  if (window.BEAEPAGEJS === undefined) {
    window.BEAEPAGEJS = [];
  }

  if (window.beaePageSetting == undefined) {
    window.beaePageSetting = {};
  }

  window.beaePageSetting.pageId = "69c5a19c5e1347e9470b4bb4";
  window.beaePageSetting.pageTitle =
    "Early Access Signup - Pastel Collection Mother's Day Edition";
  window.beaePageSetting.pageType = "page";

  let js_UH5A6S7L = () => {
    let BeaeUseHooks = {};
    try {
      let argid = "beae-zj73j56csection-js",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-zj73j56c",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-zj73j56c");
      args.el = args.els[0];
      ((t) => {
        var o;
        if (
          ((o = t.el.querySelector(".beae-grid-system")) == null ||
            o.addEventListener("scroll", (a) => {
              var r, l;
              let n = a.target;
              if (!n.classList.contains("beae-grid-carousel")) return;
              let s =
                Math.round(
                  (n.scrollLeft +
                    n.querySelector(".beae-grid-carousel__snaps").offsetLeft) /
                    (n.offsetWidth * 0.8),
                ) + 1;
              ((r = t.el.querySelector(
                ".beae-grid-carousel__pagination div.active",
              )) == null || r.classList.remove("active"),
                (l = t.el.querySelector(
                  '.beae-grid-carousel__pagination div[data-index="' + s + '"]',
                )) == null || l.classList.add("active"));
            }),
          t.mode.value == "live")
        ) {
          const a = t.el.querySelector(
              '.beae-section-background-video[data-device="desktop"]',
            ),
            n = t.el.querySelector(
              '.beae-section-background-video[data-device="mobile"]',
            ),
            s = [];
          (window.BEAEVIDEO &&
            window.BEAEVIDEO.convertBackgroundSection &&
            (window.innerWidth >= 768
              ? a &&
                window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo, a) &&
                s.push("desktop")
              : n &&
                window.BEAEVIDEO.convertBackgroundSection(
                  t.optionsVideoMobile,
                  n,
                ) &&
                s.push("mobile")),
            (a || n) &&
              window.addEventListener("resize", () => {
                if (
                  window.BEAEVIDEO &&
                  window.BEAEVIDEO.convertBackgroundSection
                ) {
                  if (!s.includes("desktop") && window.innerWidth >= 768 && a) {
                    const r = window.BEAEVIDEO.convertBackgroundSection(
                      t.optionsVideo,
                      a,
                    );
                    r && ((a.innerHTML = r.html), s.push("desktop"));
                  }
                  if (!s.includes("mobile") && window.innerWidth < 768 && n) {
                    const r = window.BEAEVIDEO.convertBackgroundSection(
                      t.optionsVideoMobile,
                      n,
                    );
                    r && ((n.innerHTML = r.html), s.push("mobile"));
                  }
                }
              }));
        }
        t.el.querySelectorAll(".beae-text-highlight").forEach((a) => {
          new IntersectionObserver(
            (s, r) => {
              s.forEach((l) => {
                l.isIntersecting &&
                  (l.target.querySelectorAll("path, line").forEach((c) => {
                    c.style.strokeDasharray =
                      parseFloat(
                        c.getAttribute("data-dash-ratio") *
                          l.target.offsetWidth *
                          2,
                      ) + "px, 999999px";
                  }),
                  r.unobserve(l.target));
              });
            },
            { root: document, rootMargin: "0px 0px -40%" },
          ).observe(a);
        });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-zj73j56c: ", ex);
    }

    try {
      let argid = "beae-wiglfiqablock-image",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-wiglfiqa",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-wiglfiqa");
      args.el = args.els[0];
      ((M) => {
        var P;
        if (M.el) {
          if (M.shape) {
            const H = M.el.closest(".beae-slider-items");
            H &&
              !H.hasAttribute("data-svg") &&
              (H == null ||
                H.closest(".beae-section").insertAdjacentHTML(
                  "beforeend",
                  `
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${M.id}" clipPathUnits="objectBoundingBox">
                                ${M.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `,
                ),
              H.setAttribute("data-svg", "true"));
          }
          let O = M.el.querySelector(".beae-image-content-position"),
            I,
            z = window.innerWidth >= 768 && M.autoHover;
          var V = O.querySelector(".beae-img-ratio-control"),
            L = O.querySelector(".beae-img-comp-container"),
            T = O.querySelector(".beae-img-comp-container--second");
          if (V && T) {
            let H = function (A) {
              let R = 0,
                j;
              (D(),
                z
                  ? (O.onmouseover = function (Z) {
                      F(Z);
                    })
                  : (A.onmousedown = function (Z) {
                      F(Z);
                    }),
                (O.onmouseup = function () {
                  q();
                }),
                (A.ontouchstart = function (Z) {
                  F(Z);
                }),
                (O.ontouchend = function () {
                  q();
                }));
              function D() {
                (new ResizeObserver(() => {
                  window.requestAnimationFrame(() => {
                    I = T.offsetWidth;
                  });
                }).observe(T),
                  A.style.left && parseInt(A.style.left));
              }
              function F(Z) {
                ((check = !1),
                  Z.preventDefault(),
                  Z.clientX ? Z.clientX : Z.touches[0].clientX,
                  parseInt(A.style.left),
                  (R = 1),
                  (O.onmousemove = function (K) {
                    G(K);
                  }),
                  (O.ontouchmove = function (K) {
                    G(K);
                  }));
              }
              function q() {
                ((R = 0), (check = !0));
              }
              function G(Z) {
                if (R == 0) return !1;
                ((j = J(Z)), j < 0 && (j = 0), j > 100 && (j = 100), W(j));
              }
              function J(Z) {
                const K = O.getBoundingClientRect(),
                  le =
                    (Z.changedTouches
                      ? Z.changedTouches[0].clientX
                      : Z.clientX) - K.left;
                return Math.max(0, Math.min(100, Math.round((le * 100) / I)));
              }
              function W(Z) {
                ((A.style.left = Z + "%"),
                  (T.style.clipPath = `polygon(${Z}% 0%, ${Z}% 100%, 100% 100%, 100% 0)`),
                  (L.style.clipPath = `polygon(0% 100%, 0% 0%, ${Z}% 0%, ${Z}% 100%)`));
              }
            };
            (V && T && H(V),
              window.addEventListener("resize", function () {
                V &&
                  T &&
                  (new ResizeObserver(() => {
                    window.requestAnimationFrame(() => {
                      I = T.offsetWidth;
                    });
                  }).observe(T),
                  H(V));
              }));
          }
        }
        let N = (P = M.el) == null ? void 0 : P.querySelector("a.beae-x-image"),
          E = N == null ? void 0 : N.getAttribute("href");
        N &&
          M.mode.value !== "builder" &&
          E != null &&
          E.includes("#") &&
          N.addEventListener("click", (O) => {
            let I = document.querySelector(
              E + "," + (E == null ? void 0 : E.replace("#", ".")),
            );
            if (I)
              return (
                I.scrollIntoView({
                  behavior: "smooth",
                  block: "center",
                  inline: "center",
                }),
                O.preventDefault(),
                !1
              );
          });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-wiglfiqa: ", ex);
    }

    try {
      let argid = "beae-ckfwgy5sblock-text",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-ckfwgy5s",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-ckfwgy5s");
      args.el = args.els[0];
      ((P) => {
        var I;
        let O =
          (I = P.el) == null ? void 0 : I.querySelectorAll(".beae-x-text a");
        O == null ||
          O.forEach((z) => {
            let H = z == null ? void 0 : z.getAttribute("href");
            z &&
              P.mode.value !== "builder" &&
              H != null &&
              H.includes("#") &&
              z.addEventListener("click", (A) => {
                let R = document.querySelector(
                  H + "," + (H == null ? void 0 : H.replace("#", ".")),
                );
                if (R)
                  return (
                    R.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                      inline: "center",
                    }),
                    A.preventDefault(),
                    !1
                  );
              });
          });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-ckfwgy5s: ", ex);
    }

    try {
      let argid = "beae-q50yiizoblock-text",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-q50yiizo",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-q50yiizo");
      args.el = args.els[0];
      ((P) => {
        var I;
        let O =
          (I = P.el) == null ? void 0 : I.querySelectorAll(".beae-x-text a");
        O == null ||
          O.forEach((z) => {
            let H = z == null ? void 0 : z.getAttribute("href");
            z &&
              P.mode.value !== "builder" &&
              H != null &&
              H.includes("#") &&
              z.addEventListener("click", (A) => {
                let R = document.querySelector(
                  H + "," + (H == null ? void 0 : H.replace("#", ".")),
                );
                if (R)
                  return (
                    R.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                      inline: "center",
                    }),
                    A.preventDefault(),
                    !1
                  );
              });
          });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-q50yiizo: ", ex);
    }

    try {
      let argid = "beae-1ibsyxzyblock-text",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-1ibsyxzy",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-1ibsyxzy");
      args.el = args.els[0];
      ((P) => {
        var I;
        let O =
          (I = P.el) == null ? void 0 : I.querySelectorAll(".beae-x-text a");
        O == null ||
          O.forEach((z) => {
            let H = z == null ? void 0 : z.getAttribute("href");
            z &&
              P.mode.value !== "builder" &&
              H != null &&
              H.includes("#") &&
              z.addEventListener("click", (A) => {
                let R = document.querySelector(
                  H + "," + (H == null ? void 0 : H.replace("#", ".")),
                );
                if (R)
                  return (
                    R.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                      inline: "center",
                    }),
                    A.preventDefault(),
                    !1
                  );
              });
          });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-1ibsyxzy: ", ex);
    }

    try {
      let argid = "beae-vnvsv1v6block-text",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-vnvsv1v6",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-vnvsv1v6");
      args.el = args.els[0];
      ((P) => {
        var I;
        let O =
          (I = P.el) == null ? void 0 : I.querySelectorAll(".beae-x-text a");
        O == null ||
          O.forEach((z) => {
            let H = z == null ? void 0 : z.getAttribute("href");
            z &&
              P.mode.value !== "builder" &&
              H != null &&
              H.includes("#") &&
              z.addEventListener("click", (A) => {
                let R = document.querySelector(
                  H + "," + (H == null ? void 0 : H.replace("#", ".")),
                );
                if (R)
                  return (
                    R.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                      inline: "center",
                    }),
                    A.preventDefault(),
                    !1
                  );
              });
          });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-vnvsv1v6: ", ex);
    }

    try {
      let argid = "beae-67p54935button-js",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-67p54935",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-67p54935");
      args.el = args.els[0];
      ((data) => {
        let buttonElm = data.el.querySelector("a.beae-button-js");
        (buttonElm == null ||
          buttonElm.addEventListener("click", (e) => {
            var n, t;
            let extOptions = {};
            if (data.extendOptions)
              try {
                eval("extOptions = " + data.extendOptions);
              } catch (o) {
                ((extOptions = {}), console.error(o));
              }
            if (data.mode.value === "builder") return (e.preventDefault(), !1);
            let selector = e.currentTarget.getAttribute("href");
            if (selector.indexOf("#") === 0 && selector !== "#") {
              let o = document.querySelector(
                selector + "," + selector.replace("#", "."),
              );
              if (o)
                return (
                  o.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                    inline: "center",
                  }),
                  e.preventDefault(),
                  !1
                );
            }
            if (data.type === "popup") {
              if (window.isPreviewTemplate) {
                let l = data.el.querySelector(
                  ".beae-content-size-chart-preview",
                );
                (window.BeaePopupLibrary.createPopup(l, {
                  id: data.id,
                  ...extOptions,
                }),
                  e.preventDefault());
                return;
              }
              const o = window.createLoading(e.currentTarget);
              let r =
                (t = (n = window.BEAE_HELPER) == null ? void 0 : n.routes) ==
                null
                  ? void 0
                  : t.root_url;
              return (
                window.BeaePopupLibrary.lightbox({
                  id: data.id,
                  url:
                    (r !== "/" ? r : "") +
                    ((data == null ? void 0 : data.url) ?? "").replace(
                      "/popup/",
                      "/?view=beae-",
                    ),
                  ...extOptions,
                }).then((l) => {
                  (l.querySelector(".beae-product-form-next") &&
                    window.handleEventFormProductCard(l),
                    o.remove());
                }),
                e.preventDefault(),
                !1
              );
            } else if (data.type === "pages" && data.lightbox) {
              let o = data.pageContent
                .replace(/&lt;/g, "<")
                .replace(/&gt;/g, ">")
                .replace(/&amp;/g, "&")
                .replace(/&quot;/g, '"')
                .replace(/&#39;/g, "'");
              return (
                window.isPreviewTemplate &&
                  (o = data.el.querySelector(
                    ".beae-content-size-chart-preview",
                  )),
                window.BeaePopupLibrary.createPopup(o, {
                  id: data.id,
                  ...extOptions,
                }),
                e.preventDefault(),
                !1
              );
            }
          }),
          data.type === "popup" &&
            data.lightbox &&
            new IntersectionObserver((t, o) => {
              t.forEach((r) => {
                r.isIntersecting && (o.unobserve(r.target), r.target.click());
              });
            }).observe(buttonElm));
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-67p54935: ", ex);
    }

    try {
      let argid = "beae-ry13fv34block-text",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-ry13fv34",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-ry13fv34");
      args.el = args.els[0];
      ((P) => {
        var I;
        let O =
          (I = P.el) == null ? void 0 : I.querySelectorAll(".beae-x-text a");
        O == null ||
          O.forEach((z) => {
            let H = z == null ? void 0 : z.getAttribute("href");
            z &&
              P.mode.value !== "builder" &&
              H != null &&
              H.includes("#") &&
              z.addEventListener("click", (A) => {
                let R = document.querySelector(
                  H + "," + (H == null ? void 0 : H.replace("#", ".")),
                );
                if (R)
                  return (
                    R.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                      inline: "center",
                    }),
                    A.preventDefault(),
                    !1
                  );
              });
          });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-ry13fv34: ", ex);
    }

    try {
      let argid = "beae-9fspo6k7block-countdown",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-9fspo6k7",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-9fspo6k7");
      args.el = args.els[0];
      ((k) => {
        k.mode.value == "builder" &&
          window.BeaeRunCountdown &&
          window.BeaeRunCountdown(k);
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-9fspo6k7: ", ex);
    }

    try {
      let argid = "beae-0ek7e010section-js",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-0ek7e010",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-0ek7e010");
      args.el = args.els[0];
      ((t) => {
        var o;
        if (
          ((o = t.el.querySelector(".beae-grid-system")) == null ||
            o.addEventListener("scroll", (a) => {
              var r, l;
              let n = a.target;
              if (!n.classList.contains("beae-grid-carousel")) return;
              let s =
                Math.round(
                  (n.scrollLeft +
                    n.querySelector(".beae-grid-carousel__snaps").offsetLeft) /
                    (n.offsetWidth * 0.8),
                ) + 1;
              ((r = t.el.querySelector(
                ".beae-grid-carousel__pagination div.active",
              )) == null || r.classList.remove("active"),
                (l = t.el.querySelector(
                  '.beae-grid-carousel__pagination div[data-index="' + s + '"]',
                )) == null || l.classList.add("active"));
            }),
          t.mode.value == "live")
        ) {
          const a = t.el.querySelector(
              '.beae-section-background-video[data-device="desktop"]',
            ),
            n = t.el.querySelector(
              '.beae-section-background-video[data-device="mobile"]',
            ),
            s = [];
          (window.BEAEVIDEO &&
            window.BEAEVIDEO.convertBackgroundSection &&
            (window.innerWidth >= 768
              ? a &&
                window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo, a) &&
                s.push("desktop")
              : n &&
                window.BEAEVIDEO.convertBackgroundSection(
                  t.optionsVideoMobile,
                  n,
                ) &&
                s.push("mobile")),
            (a || n) &&
              window.addEventListener("resize", () => {
                if (
                  window.BEAEVIDEO &&
                  window.BEAEVIDEO.convertBackgroundSection
                ) {
                  if (!s.includes("desktop") && window.innerWidth >= 768 && a) {
                    const r = window.BEAEVIDEO.convertBackgroundSection(
                      t.optionsVideo,
                      a,
                    );
                    r && ((a.innerHTML = r.html), s.push("desktop"));
                  }
                  if (!s.includes("mobile") && window.innerWidth < 768 && n) {
                    const r = window.BEAEVIDEO.convertBackgroundSection(
                      t.optionsVideoMobile,
                      n,
                    );
                    r && ((n.innerHTML = r.html), s.push("mobile"));
                  }
                }
              }));
        }
        t.el.querySelectorAll(".beae-text-highlight").forEach((a) => {
          new IntersectionObserver(
            (s, r) => {
              s.forEach((l) => {
                l.isIntersecting &&
                  (l.target.querySelectorAll("path, line").forEach((c) => {
                    c.style.strokeDasharray =
                      parseFloat(
                        c.getAttribute("data-dash-ratio") *
                          l.target.offsetWidth *
                          2,
                      ) + "px, 999999px";
                  }),
                  r.unobserve(l.target));
              });
            },
            { root: document, rootMargin: "0px 0px -40%" },
          ).observe(a);
        });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-0ek7e010: ", ex);
    }

    try {
      let argid = "beae-zrg3n9qiblock-text",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-zrg3n9qi",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-zrg3n9qi");
      args.el = args.els[0];
      ((P) => {
        var I;
        let O =
          (I = P.el) == null ? void 0 : I.querySelectorAll(".beae-x-text a");
        O == null ||
          O.forEach((z) => {
            let H = z == null ? void 0 : z.getAttribute("href");
            z &&
              P.mode.value !== "builder" &&
              H != null &&
              H.includes("#") &&
              z.addEventListener("click", (A) => {
                let R = document.querySelector(
                  H + "," + (H == null ? void 0 : H.replace("#", ".")),
                );
                if (R)
                  return (
                    R.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                      inline: "center",
                    }),
                    A.preventDefault(),
                    !1
                  );
              });
          });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-zrg3n9qi: ", ex);
    }

    try {
      let argid = "beae-dhtd91xsblock-text",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-dhtd91xs",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-dhtd91xs");
      args.el = args.els[0];
      ((P) => {
        var I;
        let O =
          (I = P.el) == null ? void 0 : I.querySelectorAll(".beae-x-text a");
        O == null ||
          O.forEach((z) => {
            let H = z == null ? void 0 : z.getAttribute("href");
            z &&
              P.mode.value !== "builder" &&
              H != null &&
              H.includes("#") &&
              z.addEventListener("click", (A) => {
                let R = document.querySelector(
                  H + "," + (H == null ? void 0 : H.replace("#", ".")),
                );
                if (R)
                  return (
                    R.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                      inline: "center",
                    }),
                    A.preventDefault(),
                    !1
                  );
              });
          });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-dhtd91xs: ", ex);
    }

    try {
      let argid = "beae-zg25nl4bsection-slide-show",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-zg25nl4b",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-zg25nl4b");
      args.el = args.els[0];
      ((g) => {
        window.BeaeSlider && !g.noRunJs && window.BeaeSlider(g);
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-zg25nl4b: ", ex);
    }

    try {
      let argid = "beae-q9h67lhtblock-imageloop-0",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-q9h67lht",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-q9h67lht");
      args.el = args.els[0];
      ((M) => {
        var P;
        if (M.el) {
          if (M.shape) {
            const H = M.el.closest(".beae-slider-items");
            H &&
              !H.hasAttribute("data-svg") &&
              (H == null ||
                H.closest(".beae-section").insertAdjacentHTML(
                  "beforeend",
                  `
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${M.id}" clipPathUnits="objectBoundingBox">
                                ${M.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `,
                ),
              H.setAttribute("data-svg", "true"));
          }
          let O = M.el.querySelector(".beae-image-content-position"),
            I,
            z = window.innerWidth >= 768 && M.autoHover;
          var V = O.querySelector(".beae-img-ratio-control"),
            L = O.querySelector(".beae-img-comp-container"),
            T = O.querySelector(".beae-img-comp-container--second");
          if (V && T) {
            let H = function (A) {
              let R = 0,
                j;
              (D(),
                z
                  ? (O.onmouseover = function (Z) {
                      F(Z);
                    })
                  : (A.onmousedown = function (Z) {
                      F(Z);
                    }),
                (O.onmouseup = function () {
                  q();
                }),
                (A.ontouchstart = function (Z) {
                  F(Z);
                }),
                (O.ontouchend = function () {
                  q();
                }));
              function D() {
                (new ResizeObserver(() => {
                  window.requestAnimationFrame(() => {
                    I = T.offsetWidth;
                  });
                }).observe(T),
                  A.style.left && parseInt(A.style.left));
              }
              function F(Z) {
                ((check = !1),
                  Z.preventDefault(),
                  Z.clientX ? Z.clientX : Z.touches[0].clientX,
                  parseInt(A.style.left),
                  (R = 1),
                  (O.onmousemove = function (K) {
                    G(K);
                  }),
                  (O.ontouchmove = function (K) {
                    G(K);
                  }));
              }
              function q() {
                ((R = 0), (check = !0));
              }
              function G(Z) {
                if (R == 0) return !1;
                ((j = J(Z)), j < 0 && (j = 0), j > 100 && (j = 100), W(j));
              }
              function J(Z) {
                const K = O.getBoundingClientRect(),
                  le =
                    (Z.changedTouches
                      ? Z.changedTouches[0].clientX
                      : Z.clientX) - K.left;
                return Math.max(0, Math.min(100, Math.round((le * 100) / I)));
              }
              function W(Z) {
                ((A.style.left = Z + "%"),
                  (T.style.clipPath = `polygon(${Z}% 0%, ${Z}% 100%, 100% 100%, 100% 0)`),
                  (L.style.clipPath = `polygon(0% 100%, 0% 0%, ${Z}% 0%, ${Z}% 100%)`));
              }
            };
            (V && T && H(V),
              window.addEventListener("resize", function () {
                V &&
                  T &&
                  (new ResizeObserver(() => {
                    window.requestAnimationFrame(() => {
                      I = T.offsetWidth;
                    });
                  }).observe(T),
                  H(V));
              }));
          }
        }
        let N = (P = M.el) == null ? void 0 : P.querySelector("a.beae-x-image"),
          E = N == null ? void 0 : N.getAttribute("href");
        N &&
          M.mode.value !== "builder" &&
          E != null &&
          E.includes("#") &&
          N.addEventListener("click", (O) => {
            let I = document.querySelector(
              E + "," + (E == null ? void 0 : E.replace("#", ".")),
            );
            if (I)
              return (
                I.scrollIntoView({
                  behavior: "smooth",
                  block: "center",
                  inline: "center",
                }),
                O.preventDefault(),
                !1
              );
          });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-q9h67lht: ", ex);
    }

    try {
      let argid = "beae-q9h67lhtblock-imageloop-1",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-q9h67lht",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-q9h67lht");
      args.el = args.els[1];
      ((M) => {
        var P;
        if (M.el) {
          if (M.shape) {
            const H = M.el.closest(".beae-slider-items");
            H &&
              !H.hasAttribute("data-svg") &&
              (H == null ||
                H.closest(".beae-section").insertAdjacentHTML(
                  "beforeend",
                  `
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${M.id}" clipPathUnits="objectBoundingBox">
                                ${M.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `,
                ),
              H.setAttribute("data-svg", "true"));
          }
          let O = M.el.querySelector(".beae-image-content-position"),
            I,
            z = window.innerWidth >= 768 && M.autoHover;
          var V = O.querySelector(".beae-img-ratio-control"),
            L = O.querySelector(".beae-img-comp-container"),
            T = O.querySelector(".beae-img-comp-container--second");
          if (V && T) {
            let H = function (A) {
              let R = 0,
                j;
              (D(),
                z
                  ? (O.onmouseover = function (Z) {
                      F(Z);
                    })
                  : (A.onmousedown = function (Z) {
                      F(Z);
                    }),
                (O.onmouseup = function () {
                  q();
                }),
                (A.ontouchstart = function (Z) {
                  F(Z);
                }),
                (O.ontouchend = function () {
                  q();
                }));
              function D() {
                (new ResizeObserver(() => {
                  window.requestAnimationFrame(() => {
                    I = T.offsetWidth;
                  });
                }).observe(T),
                  A.style.left && parseInt(A.style.left));
              }
              function F(Z) {
                ((check = !1),
                  Z.preventDefault(),
                  Z.clientX ? Z.clientX : Z.touches[0].clientX,
                  parseInt(A.style.left),
                  (R = 1),
                  (O.onmousemove = function (K) {
                    G(K);
                  }),
                  (O.ontouchmove = function (K) {
                    G(K);
                  }));
              }
              function q() {
                ((R = 0), (check = !0));
              }
              function G(Z) {
                if (R == 0) return !1;
                ((j = J(Z)), j < 0 && (j = 0), j > 100 && (j = 100), W(j));
              }
              function J(Z) {
                const K = O.getBoundingClientRect(),
                  le =
                    (Z.changedTouches
                      ? Z.changedTouches[0].clientX
                      : Z.clientX) - K.left;
                return Math.max(0, Math.min(100, Math.round((le * 100) / I)));
              }
              function W(Z) {
                ((A.style.left = Z + "%"),
                  (T.style.clipPath = `polygon(${Z}% 0%, ${Z}% 100%, 100% 100%, 100% 0)`),
                  (L.style.clipPath = `polygon(0% 100%, 0% 0%, ${Z}% 0%, ${Z}% 100%)`));
              }
            };
            (V && T && H(V),
              window.addEventListener("resize", function () {
                V &&
                  T &&
                  (new ResizeObserver(() => {
                    window.requestAnimationFrame(() => {
                      I = T.offsetWidth;
                    });
                  }).observe(T),
                  H(V));
              }));
          }
        }
        let N = (P = M.el) == null ? void 0 : P.querySelector("a.beae-x-image"),
          E = N == null ? void 0 : N.getAttribute("href");
        N &&
          M.mode.value !== "builder" &&
          E != null &&
          E.includes("#") &&
          N.addEventListener("click", (O) => {
            let I = document.querySelector(
              E + "," + (E == null ? void 0 : E.replace("#", ".")),
            );
            if (I)
              return (
                I.scrollIntoView({
                  behavior: "smooth",
                  block: "center",
                  inline: "center",
                }),
                O.preventDefault(),
                !1
              );
          });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-q9h67lht: ", ex);
    }

    try {
      let argid = "beae-q9h67lhtblock-imageloop-2",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-q9h67lht",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-q9h67lht");
      args.el = args.els[2];
      ((M) => {
        var P;
        if (M.el) {
          if (M.shape) {
            const H = M.el.closest(".beae-slider-items");
            H &&
              !H.hasAttribute("data-svg") &&
              (H == null ||
                H.closest(".beae-section").insertAdjacentHTML(
                  "beforeend",
                  `
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${M.id}" clipPathUnits="objectBoundingBox">
                                ${M.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `,
                ),
              H.setAttribute("data-svg", "true"));
          }
          let O = M.el.querySelector(".beae-image-content-position"),
            I,
            z = window.innerWidth >= 768 && M.autoHover;
          var V = O.querySelector(".beae-img-ratio-control"),
            L = O.querySelector(".beae-img-comp-container"),
            T = O.querySelector(".beae-img-comp-container--second");
          if (V && T) {
            let H = function (A) {
              let R = 0,
                j;
              (D(),
                z
                  ? (O.onmouseover = function (Z) {
                      F(Z);
                    })
                  : (A.onmousedown = function (Z) {
                      F(Z);
                    }),
                (O.onmouseup = function () {
                  q();
                }),
                (A.ontouchstart = function (Z) {
                  F(Z);
                }),
                (O.ontouchend = function () {
                  q();
                }));
              function D() {
                (new ResizeObserver(() => {
                  window.requestAnimationFrame(() => {
                    I = T.offsetWidth;
                  });
                }).observe(T),
                  A.style.left && parseInt(A.style.left));
              }
              function F(Z) {
                ((check = !1),
                  Z.preventDefault(),
                  Z.clientX ? Z.clientX : Z.touches[0].clientX,
                  parseInt(A.style.left),
                  (R = 1),
                  (O.onmousemove = function (K) {
                    G(K);
                  }),
                  (O.ontouchmove = function (K) {
                    G(K);
                  }));
              }
              function q() {
                ((R = 0), (check = !0));
              }
              function G(Z) {
                if (R == 0) return !1;
                ((j = J(Z)), j < 0 && (j = 0), j > 100 && (j = 100), W(j));
              }
              function J(Z) {
                const K = O.getBoundingClientRect(),
                  le =
                    (Z.changedTouches
                      ? Z.changedTouches[0].clientX
                      : Z.clientX) - K.left;
                return Math.max(0, Math.min(100, Math.round((le * 100) / I)));
              }
              function W(Z) {
                ((A.style.left = Z + "%"),
                  (T.style.clipPath = `polygon(${Z}% 0%, ${Z}% 100%, 100% 100%, 100% 0)`),
                  (L.style.clipPath = `polygon(0% 100%, 0% 0%, ${Z}% 0%, ${Z}% 100%)`));
              }
            };
            (V && T && H(V),
              window.addEventListener("resize", function () {
                V &&
                  T &&
                  (new ResizeObserver(() => {
                    window.requestAnimationFrame(() => {
                      I = T.offsetWidth;
                    });
                  }).observe(T),
                  H(V));
              }));
          }
        }
        let N = (P = M.el) == null ? void 0 : P.querySelector("a.beae-x-image"),
          E = N == null ? void 0 : N.getAttribute("href");
        N &&
          M.mode.value !== "builder" &&
          E != null &&
          E.includes("#") &&
          N.addEventListener("click", (O) => {
            let I = document.querySelector(
              E + "," + (E == null ? void 0 : E.replace("#", ".")),
            );
            if (I)
              return (
                I.scrollIntoView({
                  behavior: "smooth",
                  block: "center",
                  inline: "center",
                }),
                O.preventDefault(),
                !1
              );
          });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-q9h67lht: ", ex);
    }

    try {
      let argid = "beae-q9h67lhtblock-imageloop-3",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-q9h67lht",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-q9h67lht");
      args.el = args.els[3];
      ((M) => {
        var P;
        if (M.el) {
          if (M.shape) {
            const H = M.el.closest(".beae-slider-items");
            H &&
              !H.hasAttribute("data-svg") &&
              (H == null ||
                H.closest(".beae-section").insertAdjacentHTML(
                  "beforeend",
                  `
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${M.id}" clipPathUnits="objectBoundingBox">
                                ${M.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `,
                ),
              H.setAttribute("data-svg", "true"));
          }
          let O = M.el.querySelector(".beae-image-content-position"),
            I,
            z = window.innerWidth >= 768 && M.autoHover;
          var V = O.querySelector(".beae-img-ratio-control"),
            L = O.querySelector(".beae-img-comp-container"),
            T = O.querySelector(".beae-img-comp-container--second");
          if (V && T) {
            let H = function (A) {
              let R = 0,
                j;
              (D(),
                z
                  ? (O.onmouseover = function (Z) {
                      F(Z);
                    })
                  : (A.onmousedown = function (Z) {
                      F(Z);
                    }),
                (O.onmouseup = function () {
                  q();
                }),
                (A.ontouchstart = function (Z) {
                  F(Z);
                }),
                (O.ontouchend = function () {
                  q();
                }));
              function D() {
                (new ResizeObserver(() => {
                  window.requestAnimationFrame(() => {
                    I = T.offsetWidth;
                  });
                }).observe(T),
                  A.style.left && parseInt(A.style.left));
              }
              function F(Z) {
                ((check = !1),
                  Z.preventDefault(),
                  Z.clientX ? Z.clientX : Z.touches[0].clientX,
                  parseInt(A.style.left),
                  (R = 1),
                  (O.onmousemove = function (K) {
                    G(K);
                  }),
                  (O.ontouchmove = function (K) {
                    G(K);
                  }));
              }
              function q() {
                ((R = 0), (check = !0));
              }
              function G(Z) {
                if (R == 0) return !1;
                ((j = J(Z)), j < 0 && (j = 0), j > 100 && (j = 100), W(j));
              }
              function J(Z) {
                const K = O.getBoundingClientRect(),
                  le =
                    (Z.changedTouches
                      ? Z.changedTouches[0].clientX
                      : Z.clientX) - K.left;
                return Math.max(0, Math.min(100, Math.round((le * 100) / I)));
              }
              function W(Z) {
                ((A.style.left = Z + "%"),
                  (T.style.clipPath = `polygon(${Z}% 0%, ${Z}% 100%, 100% 100%, 100% 0)`),
                  (L.style.clipPath = `polygon(0% 100%, 0% 0%, ${Z}% 0%, ${Z}% 100%)`));
              }
            };
            (V && T && H(V),
              window.addEventListener("resize", function () {
                V &&
                  T &&
                  (new ResizeObserver(() => {
                    window.requestAnimationFrame(() => {
                      I = T.offsetWidth;
                    });
                  }).observe(T),
                  H(V));
              }));
          }
        }
        let N = (P = M.el) == null ? void 0 : P.querySelector("a.beae-x-image"),
          E = N == null ? void 0 : N.getAttribute("href");
        N &&
          M.mode.value !== "builder" &&
          E != null &&
          E.includes("#") &&
          N.addEventListener("click", (O) => {
            let I = document.querySelector(
              E + "," + (E == null ? void 0 : E.replace("#", ".")),
            );
            if (I)
              return (
                I.scrollIntoView({
                  behavior: "smooth",
                  block: "center",
                  inline: "center",
                }),
                O.preventDefault(),
                !1
              );
          });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-q9h67lht: ", ex);
    }

    try {
      let argid = "beae-q9h67lhtblock-imageloop-4",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-q9h67lht",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-q9h67lht");
      args.el = args.els[4];
      ((M) => {
        var P;
        if (M.el) {
          if (M.shape) {
            const H = M.el.closest(".beae-slider-items");
            H &&
              !H.hasAttribute("data-svg") &&
              (H == null ||
                H.closest(".beae-section").insertAdjacentHTML(
                  "beforeend",
                  `
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${M.id}" clipPathUnits="objectBoundingBox">
                                ${M.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `,
                ),
              H.setAttribute("data-svg", "true"));
          }
          let O = M.el.querySelector(".beae-image-content-position"),
            I,
            z = window.innerWidth >= 768 && M.autoHover;
          var V = O.querySelector(".beae-img-ratio-control"),
            L = O.querySelector(".beae-img-comp-container"),
            T = O.querySelector(".beae-img-comp-container--second");
          if (V && T) {
            let H = function (A) {
              let R = 0,
                j;
              (D(),
                z
                  ? (O.onmouseover = function (Z) {
                      F(Z);
                    })
                  : (A.onmousedown = function (Z) {
                      F(Z);
                    }),
                (O.onmouseup = function () {
                  q();
                }),
                (A.ontouchstart = function (Z) {
                  F(Z);
                }),
                (O.ontouchend = function () {
                  q();
                }));
              function D() {
                (new ResizeObserver(() => {
                  window.requestAnimationFrame(() => {
                    I = T.offsetWidth;
                  });
                }).observe(T),
                  A.style.left && parseInt(A.style.left));
              }
              function F(Z) {
                ((check = !1),
                  Z.preventDefault(),
                  Z.clientX ? Z.clientX : Z.touches[0].clientX,
                  parseInt(A.style.left),
                  (R = 1),
                  (O.onmousemove = function (K) {
                    G(K);
                  }),
                  (O.ontouchmove = function (K) {
                    G(K);
                  }));
              }
              function q() {
                ((R = 0), (check = !0));
              }
              function G(Z) {
                if (R == 0) return !1;
                ((j = J(Z)), j < 0 && (j = 0), j > 100 && (j = 100), W(j));
              }
              function J(Z) {
                const K = O.getBoundingClientRect(),
                  le =
                    (Z.changedTouches
                      ? Z.changedTouches[0].clientX
                      : Z.clientX) - K.left;
                return Math.max(0, Math.min(100, Math.round((le * 100) / I)));
              }
              function W(Z) {
                ((A.style.left = Z + "%"),
                  (T.style.clipPath = `polygon(${Z}% 0%, ${Z}% 100%, 100% 100%, 100% 0)`),
                  (L.style.clipPath = `polygon(0% 100%, 0% 0%, ${Z}% 0%, ${Z}% 100%)`));
              }
            };
            (V && T && H(V),
              window.addEventListener("resize", function () {
                V &&
                  T &&
                  (new ResizeObserver(() => {
                    window.requestAnimationFrame(() => {
                      I = T.offsetWidth;
                    });
                  }).observe(T),
                  H(V));
              }));
          }
        }
        let N = (P = M.el) == null ? void 0 : P.querySelector("a.beae-x-image"),
          E = N == null ? void 0 : N.getAttribute("href");
        N &&
          M.mode.value !== "builder" &&
          E != null &&
          E.includes("#") &&
          N.addEventListener("click", (O) => {
            let I = document.querySelector(
              E + "," + (E == null ? void 0 : E.replace("#", ".")),
            );
            if (I)
              return (
                I.scrollIntoView({
                  behavior: "smooth",
                  block: "center",
                  inline: "center",
                }),
                O.preventDefault(),
                !1
              );
          });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-q9h67lht: ", ex);
    }

    try {
      let argid = "beae-q9h67lhtblock-imageloop-5",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-q9h67lht",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-q9h67lht");
      args.el = args.els[5];
      ((M) => {
        var P;
        if (M.el) {
          if (M.shape) {
            const H = M.el.closest(".beae-slider-items");
            H &&
              !H.hasAttribute("data-svg") &&
              (H == null ||
                H.closest(".beae-section").insertAdjacentHTML(
                  "beforeend",
                  `
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${M.id}" clipPathUnits="objectBoundingBox">
                                ${M.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `,
                ),
              H.setAttribute("data-svg", "true"));
          }
          let O = M.el.querySelector(".beae-image-content-position"),
            I,
            z = window.innerWidth >= 768 && M.autoHover;
          var V = O.querySelector(".beae-img-ratio-control"),
            L = O.querySelector(".beae-img-comp-container"),
            T = O.querySelector(".beae-img-comp-container--second");
          if (V && T) {
            let H = function (A) {
              let R = 0,
                j;
              (D(),
                z
                  ? (O.onmouseover = function (Z) {
                      F(Z);
                    })
                  : (A.onmousedown = function (Z) {
                      F(Z);
                    }),
                (O.onmouseup = function () {
                  q();
                }),
                (A.ontouchstart = function (Z) {
                  F(Z);
                }),
                (O.ontouchend = function () {
                  q();
                }));
              function D() {
                (new ResizeObserver(() => {
                  window.requestAnimationFrame(() => {
                    I = T.offsetWidth;
                  });
                }).observe(T),
                  A.style.left && parseInt(A.style.left));
              }
              function F(Z) {
                ((check = !1),
                  Z.preventDefault(),
                  Z.clientX ? Z.clientX : Z.touches[0].clientX,
                  parseInt(A.style.left),
                  (R = 1),
                  (O.onmousemove = function (K) {
                    G(K);
                  }),
                  (O.ontouchmove = function (K) {
                    G(K);
                  }));
              }
              function q() {
                ((R = 0), (check = !0));
              }
              function G(Z) {
                if (R == 0) return !1;
                ((j = J(Z)), j < 0 && (j = 0), j > 100 && (j = 100), W(j));
              }
              function J(Z) {
                const K = O.getBoundingClientRect(),
                  le =
                    (Z.changedTouches
                      ? Z.changedTouches[0].clientX
                      : Z.clientX) - K.left;
                return Math.max(0, Math.min(100, Math.round((le * 100) / I)));
              }
              function W(Z) {
                ((A.style.left = Z + "%"),
                  (T.style.clipPath = `polygon(${Z}% 0%, ${Z}% 100%, 100% 100%, 100% 0)`),
                  (L.style.clipPath = `polygon(0% 100%, 0% 0%, ${Z}% 0%, ${Z}% 100%)`));
              }
            };
            (V && T && H(V),
              window.addEventListener("resize", function () {
                V &&
                  T &&
                  (new ResizeObserver(() => {
                    window.requestAnimationFrame(() => {
                      I = T.offsetWidth;
                    });
                  }).observe(T),
                  H(V));
              }));
          }
        }
        let N = (P = M.el) == null ? void 0 : P.querySelector("a.beae-x-image"),
          E = N == null ? void 0 : N.getAttribute("href");
        N &&
          M.mode.value !== "builder" &&
          E != null &&
          E.includes("#") &&
          N.addEventListener("click", (O) => {
            let I = document.querySelector(
              E + "," + (E == null ? void 0 : E.replace("#", ".")),
            );
            if (I)
              return (
                I.scrollIntoView({
                  behavior: "smooth",
                  block: "center",
                  inline: "center",
                }),
                O.preventDefault(),
                !1
              );
          });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-q9h67lht: ", ex);
    }

    try {
      let argid = "beae-g1d44wirsection-js",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-g1d44wir",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-g1d44wir");
      args.el = args.els[0];
      ((t) => {
        var o;
        if (
          ((o = t.el.querySelector(".beae-grid-system")) == null ||
            o.addEventListener("scroll", (a) => {
              var r, l;
              let n = a.target;
              if (!n.classList.contains("beae-grid-carousel")) return;
              let s =
                Math.round(
                  (n.scrollLeft +
                    n.querySelector(".beae-grid-carousel__snaps").offsetLeft) /
                    (n.offsetWidth * 0.8),
                ) + 1;
              ((r = t.el.querySelector(
                ".beae-grid-carousel__pagination div.active",
              )) == null || r.classList.remove("active"),
                (l = t.el.querySelector(
                  '.beae-grid-carousel__pagination div[data-index="' + s + '"]',
                )) == null || l.classList.add("active"));
            }),
          t.mode.value == "live")
        ) {
          const a = t.el.querySelector(
              '.beae-section-background-video[data-device="desktop"]',
            ),
            n = t.el.querySelector(
              '.beae-section-background-video[data-device="mobile"]',
            ),
            s = [];
          (window.BEAEVIDEO &&
            window.BEAEVIDEO.convertBackgroundSection &&
            (window.innerWidth >= 768
              ? a &&
                window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo, a) &&
                s.push("desktop")
              : n &&
                window.BEAEVIDEO.convertBackgroundSection(
                  t.optionsVideoMobile,
                  n,
                ) &&
                s.push("mobile")),
            (a || n) &&
              window.addEventListener("resize", () => {
                if (
                  window.BEAEVIDEO &&
                  window.BEAEVIDEO.convertBackgroundSection
                ) {
                  if (!s.includes("desktop") && window.innerWidth >= 768 && a) {
                    const r = window.BEAEVIDEO.convertBackgroundSection(
                      t.optionsVideo,
                      a,
                    );
                    r && ((a.innerHTML = r.html), s.push("desktop"));
                  }
                  if (!s.includes("mobile") && window.innerWidth < 768 && n) {
                    const r = window.BEAEVIDEO.convertBackgroundSection(
                      t.optionsVideoMobile,
                      n,
                    );
                    r && ((n.innerHTML = r.html), s.push("mobile"));
                  }
                }
              }));
        }
        t.el.querySelectorAll(".beae-text-highlight").forEach((a) => {
          new IntersectionObserver(
            (s, r) => {
              s.forEach((l) => {
                l.isIntersecting &&
                  (l.target.querySelectorAll("path, line").forEach((c) => {
                    c.style.strokeDasharray =
                      parseFloat(
                        c.getAttribute("data-dash-ratio") *
                          l.target.offsetWidth *
                          2,
                      ) + "px, 999999px";
                  }),
                  r.unobserve(l.target));
              });
            },
            { root: document, rootMargin: "0px 0px -40%" },
          ).observe(a);
        });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-g1d44wir: ", ex);
    }

    try {
      let argid = "beae-6budz3rq",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-6budz3rq",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-6budz3rq");
      args.el = args.els[0];
      ((y) => {
        var C;
        if (
          ((C = y == null ? void 0 : y.mode) == null ? void 0 : C.value) ==
            "builder" &&
          !(y != null && y.disabled)
        )
          return;
        let S = y.el.querySelector(".beae-marquee-content"),
          B = S.parentNode,
          w = (_) => {
            y.el
              .querySelectorAll(".beae-marquee-content-clone")
              .forEach((L) => L.parentNode.removeChild(L));
            let M = 0,
              V = Math.ceil(
                ((B.offsetWidth >= y.el.offsetWidth
                  ? B.offsetWidth
                  : y.el.offsetWidth) *
                  2) /
                  _.offsetWidth,
              );
            V = V <= 10 ? V : 10;
            for (let L = 0; L < V; L++) {
              let T = _.cloneNode(!0);
              T.classList.add("beae-marquee-content-clone");
              const N = T.querySelectorAll("img");
              (N.length > 0 &&
                N.forEach((E) => {
                  (E.setAttribute("loading", "lazy"),
                    E.setAttribute("load", "true"));
                }),
                B.appendChild(T),
                M < y.el.offsetWidth && (M += _.offsetWidth));
            }
            (B.style.setProperty(
              "--marquee-animation-duration",
              (M / 10) * 0.01 * ((y == null ? void 0 : y.speed) ?? 10) + "s",
            ),
              B.style.setProperty("--marquee-animation-offset", -M + "px"),
              window.dispatchEvent(
                new CustomEvent("marqueeClone", {
                  detail: { id: y == null ? void 0 : y.id },
                }),
              ));
          };
        (window.addEventListener("resize", () => {
          w(S);
        }),
          w(S));
        let $ = new IntersectionObserver((_) => {
          _.forEach((M) => {
            M.intersectionRatio > 0 &&
              (w(S),
              M.target.querySelectorAll('[loading="lazy"]').forEach((V) => {
                V.removeAttribute("loading");
              }),
              $.unobserve(M.target));
          });
        }, {});
        $.observe(B);
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-6budz3rq: ", ex);
    }

    try {
      let argid = "beae-ieqflhrcblock-textloop-0",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-ieqflhrc",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-ieqflhrc");
      args.el = args.els[0];
      ((P) => {
        var I;
        let O =
          (I = P.el) == null ? void 0 : I.querySelectorAll(".beae-x-text a");
        O == null ||
          O.forEach((z) => {
            let H = z == null ? void 0 : z.getAttribute("href");
            z &&
              P.mode.value !== "builder" &&
              H != null &&
              H.includes("#") &&
              z.addEventListener("click", (A) => {
                let R = document.querySelector(
                  H + "," + (H == null ? void 0 : H.replace("#", ".")),
                );
                if (R)
                  return (
                    R.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                      inline: "center",
                    }),
                    A.preventDefault(),
                    !1
                  );
              });
          });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-ieqflhrc: ", ex);
    }

    try {
      let argid = "beae-ieqflhrcblock-textloop-1",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-ieqflhrc",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-ieqflhrc");
      args.el = args.els[1];
      ((P) => {
        var I;
        let O =
          (I = P.el) == null ? void 0 : I.querySelectorAll(".beae-x-text a");
        O == null ||
          O.forEach((z) => {
            let H = z == null ? void 0 : z.getAttribute("href");
            z &&
              P.mode.value !== "builder" &&
              H != null &&
              H.includes("#") &&
              z.addEventListener("click", (A) => {
                let R = document.querySelector(
                  H + "," + (H == null ? void 0 : H.replace("#", ".")),
                );
                if (R)
                  return (
                    R.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                      inline: "center",
                    }),
                    A.preventDefault(),
                    !1
                  );
              });
          });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-ieqflhrc: ", ex);
    }

    try {
      let argid = "beae-277k1zapsection-js",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-277k1zap",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-277k1zap");
      args.el = args.els[0];
      ((t) => {
        var o;
        if (
          ((o = t.el.querySelector(".beae-grid-system")) == null ||
            o.addEventListener("scroll", (a) => {
              var r, l;
              let n = a.target;
              if (!n.classList.contains("beae-grid-carousel")) return;
              let s =
                Math.round(
                  (n.scrollLeft +
                    n.querySelector(".beae-grid-carousel__snaps").offsetLeft) /
                    (n.offsetWidth * 0.8),
                ) + 1;
              ((r = t.el.querySelector(
                ".beae-grid-carousel__pagination div.active",
              )) == null || r.classList.remove("active"),
                (l = t.el.querySelector(
                  '.beae-grid-carousel__pagination div[data-index="' + s + '"]',
                )) == null || l.classList.add("active"));
            }),
          t.mode.value == "live")
        ) {
          const a = t.el.querySelector(
              '.beae-section-background-video[data-device="desktop"]',
            ),
            n = t.el.querySelector(
              '.beae-section-background-video[data-device="mobile"]',
            ),
            s = [];
          (window.BEAEVIDEO &&
            window.BEAEVIDEO.convertBackgroundSection &&
            (window.innerWidth >= 768
              ? a &&
                window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo, a) &&
                s.push("desktop")
              : n &&
                window.BEAEVIDEO.convertBackgroundSection(
                  t.optionsVideoMobile,
                  n,
                ) &&
                s.push("mobile")),
            (a || n) &&
              window.addEventListener("resize", () => {
                if (
                  window.BEAEVIDEO &&
                  window.BEAEVIDEO.convertBackgroundSection
                ) {
                  if (!s.includes("desktop") && window.innerWidth >= 768 && a) {
                    const r = window.BEAEVIDEO.convertBackgroundSection(
                      t.optionsVideo,
                      a,
                    );
                    r && ((a.innerHTML = r.html), s.push("desktop"));
                  }
                  if (!s.includes("mobile") && window.innerWidth < 768 && n) {
                    const r = window.BEAEVIDEO.convertBackgroundSection(
                      t.optionsVideoMobile,
                      n,
                    );
                    r && ((n.innerHTML = r.html), s.push("mobile"));
                  }
                }
              }));
        }
        t.el.querySelectorAll(".beae-text-highlight").forEach((a) => {
          new IntersectionObserver(
            (s, r) => {
              s.forEach((l) => {
                l.isIntersecting &&
                  (l.target.querySelectorAll("path, line").forEach((c) => {
                    c.style.strokeDasharray =
                      parseFloat(
                        c.getAttribute("data-dash-ratio") *
                          l.target.offsetWidth *
                          2,
                      ) + "px, 999999px";
                  }),
                  r.unobserve(l.target));
              });
            },
            { root: document, rootMargin: "0px 0px -40%" },
          ).observe(a);
        });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-277k1zap: ", ex);
    }

    try {
      let argid = "beae-pjk3xwarsection-slide-show",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-pjk3xwar",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-pjk3xwar");
      args.el = args.els[0];
      ((g) => {
        window.BeaeSlider && !g.noRunJs && window.BeaeSlider(g);
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-pjk3xwar: ", ex);
    }

    try {
      let argid = "beae-4s781x55block-textloop-0",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-4s781x55",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-4s781x55");
      args.el = args.els[0];
      ((P) => {
        var I;
        let O =
          (I = P.el) == null ? void 0 : I.querySelectorAll(".beae-x-text a");
        O == null ||
          O.forEach((z) => {
            let H = z == null ? void 0 : z.getAttribute("href");
            z &&
              P.mode.value !== "builder" &&
              H != null &&
              H.includes("#") &&
              z.addEventListener("click", (A) => {
                let R = document.querySelector(
                  H + "," + (H == null ? void 0 : H.replace("#", ".")),
                );
                if (R)
                  return (
                    R.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                      inline: "center",
                    }),
                    A.preventDefault(),
                    !1
                  );
              });
          });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-4s781x55: ", ex);
    }

    try {
      let argid = "beae-5t11aq2bblock-textloop-0",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-5t11aq2b",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-5t11aq2b");
      args.el = args.els[0];
      ((P) => {
        var I;
        let O =
          (I = P.el) == null ? void 0 : I.querySelectorAll(".beae-x-text a");
        O == null ||
          O.forEach((z) => {
            let H = z == null ? void 0 : z.getAttribute("href");
            z &&
              P.mode.value !== "builder" &&
              H != null &&
              H.includes("#") &&
              z.addEventListener("click", (A) => {
                let R = document.querySelector(
                  H + "," + (H == null ? void 0 : H.replace("#", ".")),
                );
                if (R)
                  return (
                    R.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                      inline: "center",
                    }),
                    A.preventDefault(),
                    !1
                  );
              });
          });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-5t11aq2b: ", ex);
    }

    try {
      let argid = "beae-87ohadxvblock-textloop-0",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-87ohadxv",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-87ohadxv");
      args.el = args.els[0];
      ((P) => {
        var I;
        let O =
          (I = P.el) == null ? void 0 : I.querySelectorAll(".beae-x-text a");
        O == null ||
          O.forEach((z) => {
            let H = z == null ? void 0 : z.getAttribute("href");
            z &&
              P.mode.value !== "builder" &&
              H != null &&
              H.includes("#") &&
              z.addEventListener("click", (A) => {
                let R = document.querySelector(
                  H + "," + (H == null ? void 0 : H.replace("#", ".")),
                );
                if (R)
                  return (
                    R.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                      inline: "center",
                    }),
                    A.preventDefault(),
                    !1
                  );
              });
          });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-87ohadxv: ", ex);
    }

    try {
      let argid = "beae-9hlgt8jlsection-js",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-9hlgt8jl",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-9hlgt8jl");
      args.el = args.els[0];
      ((t) => {
        var o;
        if (
          ((o = t.el.querySelector(".beae-grid-system")) == null ||
            o.addEventListener("scroll", (a) => {
              var r, l;
              let n = a.target;
              if (!n.classList.contains("beae-grid-carousel")) return;
              let s =
                Math.round(
                  (n.scrollLeft +
                    n.querySelector(".beae-grid-carousel__snaps").offsetLeft) /
                    (n.offsetWidth * 0.8),
                ) + 1;
              ((r = t.el.querySelector(
                ".beae-grid-carousel__pagination div.active",
              )) == null || r.classList.remove("active"),
                (l = t.el.querySelector(
                  '.beae-grid-carousel__pagination div[data-index="' + s + '"]',
                )) == null || l.classList.add("active"));
            }),
          t.mode.value == "live")
        ) {
          const a = t.el.querySelector(
              '.beae-section-background-video[data-device="desktop"]',
            ),
            n = t.el.querySelector(
              '.beae-section-background-video[data-device="mobile"]',
            ),
            s = [];
          (window.BEAEVIDEO &&
            window.BEAEVIDEO.convertBackgroundSection &&
            (window.innerWidth >= 768
              ? a &&
                window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo, a) &&
                s.push("desktop")
              : n &&
                window.BEAEVIDEO.convertBackgroundSection(
                  t.optionsVideoMobile,
                  n,
                ) &&
                s.push("mobile")),
            (a || n) &&
              window.addEventListener("resize", () => {
                if (
                  window.BEAEVIDEO &&
                  window.BEAEVIDEO.convertBackgroundSection
                ) {
                  if (!s.includes("desktop") && window.innerWidth >= 768 && a) {
                    const r = window.BEAEVIDEO.convertBackgroundSection(
                      t.optionsVideo,
                      a,
                    );
                    r && ((a.innerHTML = r.html), s.push("desktop"));
                  }
                  if (!s.includes("mobile") && window.innerWidth < 768 && n) {
                    const r = window.BEAEVIDEO.convertBackgroundSection(
                      t.optionsVideoMobile,
                      n,
                    );
                    r && ((n.innerHTML = r.html), s.push("mobile"));
                  }
                }
              }));
        }
        t.el.querySelectorAll(".beae-text-highlight").forEach((a) => {
          new IntersectionObserver(
            (s, r) => {
              s.forEach((l) => {
                l.isIntersecting &&
                  (l.target.querySelectorAll("path, line").forEach((c) => {
                    c.style.strokeDasharray =
                      parseFloat(
                        c.getAttribute("data-dash-ratio") *
                          l.target.offsetWidth *
                          2,
                      ) + "px, 999999px";
                  }),
                  r.unobserve(l.target));
              });
            },
            { root: document, rootMargin: "0px 0px -40%" },
          ).observe(a);
        });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-9hlgt8jl: ", ex);
    }

    try {
      let argid = "beae-3j2btgfnblock-text",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-3j2btgfn",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-3j2btgfn");
      args.el = args.els[0];
      ((P) => {
        var I;
        let O =
          (I = P.el) == null ? void 0 : I.querySelectorAll(".beae-x-text a");
        O == null ||
          O.forEach((z) => {
            let H = z == null ? void 0 : z.getAttribute("href");
            z &&
              P.mode.value !== "builder" &&
              H != null &&
              H.includes("#") &&
              z.addEventListener("click", (A) => {
                let R = document.querySelector(
                  H + "," + (H == null ? void 0 : H.replace("#", ".")),
                );
                if (R)
                  return (
                    R.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                      inline: "center",
                    }),
                    A.preventDefault(),
                    !1
                  );
              });
          });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-3j2btgfn: ", ex);
    }

    try {
      let argid = "beae-7v7p1vr2block-text",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-7v7p1vr2",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-7v7p1vr2");
      args.el = args.els[0];
      ((P) => {
        var I;
        let O =
          (I = P.el) == null ? void 0 : I.querySelectorAll(".beae-x-text a");
        O == null ||
          O.forEach((z) => {
            let H = z == null ? void 0 : z.getAttribute("href");
            z &&
              P.mode.value !== "builder" &&
              H != null &&
              H.includes("#") &&
              z.addEventListener("click", (A) => {
                let R = document.querySelector(
                  H + "," + (H == null ? void 0 : H.replace("#", ".")),
                );
                if (R)
                  return (
                    R.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                      inline: "center",
                    }),
                    A.preventDefault(),
                    !1
                  );
              });
          });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-7v7p1vr2: ", ex);
    }

    try {
      let argid = "beae-6y5nuiibbutton-js",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-6y5nuiib",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-6y5nuiib");
      args.el = args.els[0];
      ((data) => {
        let buttonElm = data.el.querySelector("a.beae-button-js");
        (buttonElm == null ||
          buttonElm.addEventListener("click", (e) => {
            var n, t;
            let extOptions = {};
            if (data.extendOptions)
              try {
                eval("extOptions = " + data.extendOptions);
              } catch (o) {
                ((extOptions = {}), console.error(o));
              }
            if (data.mode.value === "builder") return (e.preventDefault(), !1);
            let selector = e.currentTarget.getAttribute("href");
            if (selector.indexOf("#") === 0 && selector !== "#") {
              let o = document.querySelector(
                selector + "," + selector.replace("#", "."),
              );
              if (o)
                return (
                  o.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                    inline: "center",
                  }),
                  e.preventDefault(),
                  !1
                );
            }
            if (data.type === "popup") {
              if (window.isPreviewTemplate) {
                let l = data.el.querySelector(
                  ".beae-content-size-chart-preview",
                );
                (window.BeaePopupLibrary.createPopup(l, {
                  id: data.id,
                  ...extOptions,
                }),
                  e.preventDefault());
                return;
              }
              const o = window.createLoading(e.currentTarget);
              let r =
                (t = (n = window.BEAE_HELPER) == null ? void 0 : n.routes) ==
                null
                  ? void 0
                  : t.root_url;
              return (
                window.BeaePopupLibrary.lightbox({
                  id: data.id,
                  url:
                    (r !== "/" ? r : "") +
                    ((data == null ? void 0 : data.url) ?? "").replace(
                      "/popup/",
                      "/?view=beae-",
                    ),
                  ...extOptions,
                }).then((l) => {
                  (l.querySelector(".beae-product-form-next") &&
                    window.handleEventFormProductCard(l),
                    o.remove());
                }),
                e.preventDefault(),
                !1
              );
            } else if (data.type === "pages" && data.lightbox) {
              let o = data.pageContent
                .replace(/&lt;/g, "<")
                .replace(/&gt;/g, ">")
                .replace(/&amp;/g, "&")
                .replace(/&quot;/g, '"')
                .replace(/&#39;/g, "'");
              return (
                window.isPreviewTemplate &&
                  (o = data.el.querySelector(
                    ".beae-content-size-chart-preview",
                  )),
                window.BeaePopupLibrary.createPopup(o, {
                  id: data.id,
                  ...extOptions,
                }),
                e.preventDefault(),
                !1
              );
            }
          }),
          data.type === "popup" &&
            data.lightbox &&
            new IntersectionObserver((t, o) => {
              t.forEach((r) => {
                r.isIntersecting && (o.unobserve(r.target), r.target.click());
              });
            }).observe(buttonElm));
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-6y5nuiib: ", ex);
    }

    try {
      let argid = "beae-vri8dcs5block-image",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-vri8dcs5",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-vri8dcs5");
      args.el = args.els[0];
      ((M) => {
        var P;
        if (M.el) {
          if (M.shape) {
            const H = M.el.closest(".beae-slider-items");
            H &&
              !H.hasAttribute("data-svg") &&
              (H == null ||
                H.closest(".beae-section").insertAdjacentHTML(
                  "beforeend",
                  `
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${M.id}" clipPathUnits="objectBoundingBox">
                                ${M.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `,
                ),
              H.setAttribute("data-svg", "true"));
          }
          let O = M.el.querySelector(".beae-image-content-position"),
            I,
            z = window.innerWidth >= 768 && M.autoHover;
          var V = O.querySelector(".beae-img-ratio-control"),
            L = O.querySelector(".beae-img-comp-container"),
            T = O.querySelector(".beae-img-comp-container--second");
          if (V && T) {
            let H = function (A) {
              let R = 0,
                j;
              (D(),
                z
                  ? (O.onmouseover = function (Z) {
                      F(Z);
                    })
                  : (A.onmousedown = function (Z) {
                      F(Z);
                    }),
                (O.onmouseup = function () {
                  q();
                }),
                (A.ontouchstart = function (Z) {
                  F(Z);
                }),
                (O.ontouchend = function () {
                  q();
                }));
              function D() {
                (new ResizeObserver(() => {
                  window.requestAnimationFrame(() => {
                    I = T.offsetWidth;
                  });
                }).observe(T),
                  A.style.left && parseInt(A.style.left));
              }
              function F(Z) {
                ((check = !1),
                  Z.preventDefault(),
                  Z.clientX ? Z.clientX : Z.touches[0].clientX,
                  parseInt(A.style.left),
                  (R = 1),
                  (O.onmousemove = function (K) {
                    G(K);
                  }),
                  (O.ontouchmove = function (K) {
                    G(K);
                  }));
              }
              function q() {
                ((R = 0), (check = !0));
              }
              function G(Z) {
                if (R == 0) return !1;
                ((j = J(Z)), j < 0 && (j = 0), j > 100 && (j = 100), W(j));
              }
              function J(Z) {
                const K = O.getBoundingClientRect(),
                  le =
                    (Z.changedTouches
                      ? Z.changedTouches[0].clientX
                      : Z.clientX) - K.left;
                return Math.max(0, Math.min(100, Math.round((le * 100) / I)));
              }
              function W(Z) {
                ((A.style.left = Z + "%"),
                  (T.style.clipPath = `polygon(${Z}% 0%, ${Z}% 100%, 100% 100%, 100% 0)`),
                  (L.style.clipPath = `polygon(0% 100%, 0% 0%, ${Z}% 0%, ${Z}% 100%)`));
              }
            };
            (V && T && H(V),
              window.addEventListener("resize", function () {
                V &&
                  T &&
                  (new ResizeObserver(() => {
                    window.requestAnimationFrame(() => {
                      I = T.offsetWidth;
                    });
                  }).observe(T),
                  H(V));
              }));
          }
        }
        let N = (P = M.el) == null ? void 0 : P.querySelector("a.beae-x-image"),
          E = N == null ? void 0 : N.getAttribute("href");
        N &&
          M.mode.value !== "builder" &&
          E != null &&
          E.includes("#") &&
          N.addEventListener("click", (O) => {
            let I = document.querySelector(
              E + "," + (E == null ? void 0 : E.replace("#", ".")),
            );
            if (I)
              return (
                I.scrollIntoView({
                  behavior: "smooth",
                  block: "center",
                  inline: "center",
                }),
                O.preventDefault(),
                !1
              );
          });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-vri8dcs5: ", ex);
    }

    try {
      let argid = "beae-5f8pbx8gblock-image",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-5f8pbx8g",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-5f8pbx8g");
      args.el = args.els[0];
      ((M) => {
        var P;
        if (M.el) {
          if (M.shape) {
            const H = M.el.closest(".beae-slider-items");
            H &&
              !H.hasAttribute("data-svg") &&
              (H == null ||
                H.closest(".beae-section").insertAdjacentHTML(
                  "beforeend",
                  `
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${M.id}" clipPathUnits="objectBoundingBox">
                                ${M.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `,
                ),
              H.setAttribute("data-svg", "true"));
          }
          let O = M.el.querySelector(".beae-image-content-position"),
            I,
            z = window.innerWidth >= 768 && M.autoHover;
          var V = O.querySelector(".beae-img-ratio-control"),
            L = O.querySelector(".beae-img-comp-container"),
            T = O.querySelector(".beae-img-comp-container--second");
          if (V && T) {
            let H = function (A) {
              let R = 0,
                j;
              (D(),
                z
                  ? (O.onmouseover = function (Z) {
                      F(Z);
                    })
                  : (A.onmousedown = function (Z) {
                      F(Z);
                    }),
                (O.onmouseup = function () {
                  q();
                }),
                (A.ontouchstart = function (Z) {
                  F(Z);
                }),
                (O.ontouchend = function () {
                  q();
                }));
              function D() {
                (new ResizeObserver(() => {
                  window.requestAnimationFrame(() => {
                    I = T.offsetWidth;
                  });
                }).observe(T),
                  A.style.left && parseInt(A.style.left));
              }
              function F(Z) {
                ((check = !1),
                  Z.preventDefault(),
                  Z.clientX ? Z.clientX : Z.touches[0].clientX,
                  parseInt(A.style.left),
                  (R = 1),
                  (O.onmousemove = function (K) {
                    G(K);
                  }),
                  (O.ontouchmove = function (K) {
                    G(K);
                  }));
              }
              function q() {
                ((R = 0), (check = !0));
              }
              function G(Z) {
                if (R == 0) return !1;
                ((j = J(Z)), j < 0 && (j = 0), j > 100 && (j = 100), W(j));
              }
              function J(Z) {
                const K = O.getBoundingClientRect(),
                  le =
                    (Z.changedTouches
                      ? Z.changedTouches[0].clientX
                      : Z.clientX) - K.left;
                return Math.max(0, Math.min(100, Math.round((le * 100) / I)));
              }
              function W(Z) {
                ((A.style.left = Z + "%"),
                  (T.style.clipPath = `polygon(${Z}% 0%, ${Z}% 100%, 100% 100%, 100% 0)`),
                  (L.style.clipPath = `polygon(0% 100%, 0% 0%, ${Z}% 0%, ${Z}% 100%)`));
              }
            };
            (V && T && H(V),
              window.addEventListener("resize", function () {
                V &&
                  T &&
                  (new ResizeObserver(() => {
                    window.requestAnimationFrame(() => {
                      I = T.offsetWidth;
                    });
                  }).observe(T),
                  H(V));
              }));
          }
        }
        let N = (P = M.el) == null ? void 0 : P.querySelector("a.beae-x-image"),
          E = N == null ? void 0 : N.getAttribute("href");
        N &&
          M.mode.value !== "builder" &&
          E != null &&
          E.includes("#") &&
          N.addEventListener("click", (O) => {
            let I = document.querySelector(
              E + "," + (E == null ? void 0 : E.replace("#", ".")),
            );
            if (I)
              return (
                I.scrollIntoView({
                  behavior: "smooth",
                  block: "center",
                  inline: "center",
                }),
                O.preventDefault(),
                !1
              );
          });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-5f8pbx8g: ", ex);
    }

    try {
      let argid = "beae-jsmkadmablock-text",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-jsmkadma",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-jsmkadma");
      args.el = args.els[0];
      ((P) => {
        var I;
        let O =
          (I = P.el) == null ? void 0 : I.querySelectorAll(".beae-x-text a");
        O == null ||
          O.forEach((z) => {
            let H = z == null ? void 0 : z.getAttribute("href");
            z &&
              P.mode.value !== "builder" &&
              H != null &&
              H.includes("#") &&
              z.addEventListener("click", (A) => {
                let R = document.querySelector(
                  H + "," + (H == null ? void 0 : H.replace("#", ".")),
                );
                if (R)
                  return (
                    R.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                      inline: "center",
                    }),
                    A.preventDefault(),
                    !1
                  );
              });
          });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-jsmkadma: ", ex);
    }

    try {
      let argid = "beae-anh362yjblock-text",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-anh362yj",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-anh362yj");
      args.el = args.els[0];
      ((P) => {
        var I;
        let O =
          (I = P.el) == null ? void 0 : I.querySelectorAll(".beae-x-text a");
        O == null ||
          O.forEach((z) => {
            let H = z == null ? void 0 : z.getAttribute("href");
            z &&
              P.mode.value !== "builder" &&
              H != null &&
              H.includes("#") &&
              z.addEventListener("click", (A) => {
                let R = document.querySelector(
                  H + "," + (H == null ? void 0 : H.replace("#", ".")),
                );
                if (R)
                  return (
                    R.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                      inline: "center",
                    }),
                    A.preventDefault(),
                    !1
                  );
              });
          });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-anh362yj: ", ex);
    }

    try {
      let argid = "beae-11ld08u3button-js",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-11ld08u3",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-11ld08u3");
      args.el = args.els[0];
      ((data) => {
        let buttonElm = data.el.querySelector("a.beae-button-js");
        (buttonElm == null ||
          buttonElm.addEventListener("click", (e) => {
            var n, t;
            let extOptions = {};
            if (data.extendOptions)
              try {
                eval("extOptions = " + data.extendOptions);
              } catch (o) {
                ((extOptions = {}), console.error(o));
              }
            if (data.mode.value === "builder") return (e.preventDefault(), !1);
            let selector = e.currentTarget.getAttribute("href");
            if (selector.indexOf("#") === 0 && selector !== "#") {
              let o = document.querySelector(
                selector + "," + selector.replace("#", "."),
              );
              if (o)
                return (
                  o.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                    inline: "center",
                  }),
                  e.preventDefault(),
                  !1
                );
            }
            if (data.type === "popup") {
              if (window.isPreviewTemplate) {
                let l = data.el.querySelector(
                  ".beae-content-size-chart-preview",
                );
                (window.BeaePopupLibrary.createPopup(l, {
                  id: data.id,
                  ...extOptions,
                }),
                  e.preventDefault());
                return;
              }
              const o = window.createLoading(e.currentTarget);
              let r =
                (t = (n = window.BEAE_HELPER) == null ? void 0 : n.routes) ==
                null
                  ? void 0
                  : t.root_url;
              return (
                window.BeaePopupLibrary.lightbox({
                  id: data.id,
                  url:
                    (r !== "/" ? r : "") +
                    ((data == null ? void 0 : data.url) ?? "").replace(
                      "/popup/",
                      "/?view=beae-",
                    ),
                  ...extOptions,
                }).then((l) => {
                  (l.querySelector(".beae-product-form-next") &&
                    window.handleEventFormProductCard(l),
                    o.remove());
                }),
                e.preventDefault(),
                !1
              );
            } else if (data.type === "pages" && data.lightbox) {
              let o = data.pageContent
                .replace(/&lt;/g, "<")
                .replace(/&gt;/g, ">")
                .replace(/&amp;/g, "&")
                .replace(/&quot;/g, '"')
                .replace(/&#39;/g, "'");
              return (
                window.isPreviewTemplate &&
                  (o = data.el.querySelector(
                    ".beae-content-size-chart-preview",
                  )),
                window.BeaePopupLibrary.createPopup(o, {
                  id: data.id,
                  ...extOptions,
                }),
                e.preventDefault(),
                !1
              );
            }
          }),
          data.type === "popup" &&
            data.lightbox &&
            new IntersectionObserver((t, o) => {
              t.forEach((r) => {
                r.isIntersecting && (o.unobserve(r.target), r.target.click());
              });
            }).observe(buttonElm));
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-11ld08u3: ", ex);
    }

    try {
      let argid = "beae-bmff43h0section-js",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-bmff43h0",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-bmff43h0");
      args.el = args.els[0];
      ((t) => {
        var o;
        if (
          ((o = t.el.querySelector(".beae-grid-system")) == null ||
            o.addEventListener("scroll", (a) => {
              var r, l;
              let n = a.target;
              if (!n.classList.contains("beae-grid-carousel")) return;
              let s =
                Math.round(
                  (n.scrollLeft +
                    n.querySelector(".beae-grid-carousel__snaps").offsetLeft) /
                    (n.offsetWidth * 0.8),
                ) + 1;
              ((r = t.el.querySelector(
                ".beae-grid-carousel__pagination div.active",
              )) == null || r.classList.remove("active"),
                (l = t.el.querySelector(
                  '.beae-grid-carousel__pagination div[data-index="' + s + '"]',
                )) == null || l.classList.add("active"));
            }),
          t.mode.value == "live")
        ) {
          const a = t.el.querySelector(
              '.beae-section-background-video[data-device="desktop"]',
            ),
            n = t.el.querySelector(
              '.beae-section-background-video[data-device="mobile"]',
            ),
            s = [];
          (window.BEAEVIDEO &&
            window.BEAEVIDEO.convertBackgroundSection &&
            (window.innerWidth >= 768
              ? a &&
                window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo, a) &&
                s.push("desktop")
              : n &&
                window.BEAEVIDEO.convertBackgroundSection(
                  t.optionsVideoMobile,
                  n,
                ) &&
                s.push("mobile")),
            (a || n) &&
              window.addEventListener("resize", () => {
                if (
                  window.BEAEVIDEO &&
                  window.BEAEVIDEO.convertBackgroundSection
                ) {
                  if (!s.includes("desktop") && window.innerWidth >= 768 && a) {
                    const r = window.BEAEVIDEO.convertBackgroundSection(
                      t.optionsVideo,
                      a,
                    );
                    r && ((a.innerHTML = r.html), s.push("desktop"));
                  }
                  if (!s.includes("mobile") && window.innerWidth < 768 && n) {
                    const r = window.BEAEVIDEO.convertBackgroundSection(
                      t.optionsVideoMobile,
                      n,
                    );
                    r && ((n.innerHTML = r.html), s.push("mobile"));
                  }
                }
              }));
        }
        t.el.querySelectorAll(".beae-text-highlight").forEach((a) => {
          new IntersectionObserver(
            (s, r) => {
              s.forEach((l) => {
                l.isIntersecting &&
                  (l.target.querySelectorAll("path, line").forEach((c) => {
                    c.style.strokeDasharray =
                      parseFloat(
                        c.getAttribute("data-dash-ratio") *
                          l.target.offsetWidth *
                          2,
                      ) + "px, 999999px";
                  }),
                  r.unobserve(l.target));
              });
            },
            { root: document, rootMargin: "0px 0px -40%" },
          ).observe(a);
        });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-bmff43h0: ", ex);
    }

    try {
      let argid = "beae-tu6fdzjhblock-text",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-tu6fdzjh",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-tu6fdzjh");
      args.el = args.els[0];
      ((P) => {
        var I;
        let O =
          (I = P.el) == null ? void 0 : I.querySelectorAll(".beae-x-text a");
        O == null ||
          O.forEach((z) => {
            let H = z == null ? void 0 : z.getAttribute("href");
            z &&
              P.mode.value !== "builder" &&
              H != null &&
              H.includes("#") &&
              z.addEventListener("click", (A) => {
                let R = document.querySelector(
                  H + "," + (H == null ? void 0 : H.replace("#", ".")),
                );
                if (R)
                  return (
                    R.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                      inline: "center",
                    }),
                    A.preventDefault(),
                    !1
                  );
              });
          });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-tu6fdzjh: ", ex);
    }

    try {
      let argid = "beae-043xb1svblock-text",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-043xb1sv",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-043xb1sv");
      args.el = args.els[0];
      ((P) => {
        var I;
        let O =
          (I = P.el) == null ? void 0 : I.querySelectorAll(".beae-x-text a");
        O == null ||
          O.forEach((z) => {
            let H = z == null ? void 0 : z.getAttribute("href");
            z &&
              P.mode.value !== "builder" &&
              H != null &&
              H.includes("#") &&
              z.addEventListener("click", (A) => {
                let R = document.querySelector(
                  H + "," + (H == null ? void 0 : H.replace("#", ".")),
                );
                if (R)
                  return (
                    R.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                      inline: "center",
                    }),
                    A.preventDefault(),
                    !1
                  );
              });
          });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-043xb1sv: ", ex);
    }

    try {
      let argid = "beae-qzrorzmlbutton-js",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-qzrorzml",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-qzrorzml");
      args.el = args.els[0];
      ((data) => {
        let buttonElm = data.el.querySelector("a.beae-button-js");
        (buttonElm == null ||
          buttonElm.addEventListener("click", (e) => {
            var n, t;
            let extOptions = {};
            if (data.extendOptions)
              try {
                eval("extOptions = " + data.extendOptions);
              } catch (o) {
                ((extOptions = {}), console.error(o));
              }
            if (data.mode.value === "builder") return (e.preventDefault(), !1);
            let selector = e.currentTarget.getAttribute("href");
            if (selector.indexOf("#") === 0 && selector !== "#") {
              let o = document.querySelector(
                selector + "," + selector.replace("#", "."),
              );
              if (o)
                return (
                  o.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                    inline: "center",
                  }),
                  e.preventDefault(),
                  !1
                );
            }
            if (data.type === "popup") {
              if (window.isPreviewTemplate) {
                let l = data.el.querySelector(
                  ".beae-content-size-chart-preview",
                );
                (window.BeaePopupLibrary.createPopup(l, {
                  id: data.id,
                  ...extOptions,
                }),
                  e.preventDefault());
                return;
              }
              const o = window.createLoading(e.currentTarget);
              let r =
                (t = (n = window.BEAE_HELPER) == null ? void 0 : n.routes) ==
                null
                  ? void 0
                  : t.root_url;
              return (
                window.BeaePopupLibrary.lightbox({
                  id: data.id,
                  url:
                    (r !== "/" ? r : "") +
                    ((data == null ? void 0 : data.url) ?? "").replace(
                      "/popup/",
                      "/?view=beae-",
                    ),
                  ...extOptions,
                }).then((l) => {
                  (l.querySelector(".beae-product-form-next") &&
                    window.handleEventFormProductCard(l),
                    o.remove());
                }),
                e.preventDefault(),
                !1
              );
            } else if (data.type === "pages" && data.lightbox) {
              let o = data.pageContent
                .replace(/&lt;/g, "<")
                .replace(/&gt;/g, ">")
                .replace(/&amp;/g, "&")
                .replace(/&quot;/g, '"')
                .replace(/&#39;/g, "'");
              return (
                window.isPreviewTemplate &&
                  (o = data.el.querySelector(
                    ".beae-content-size-chart-preview",
                  )),
                window.BeaePopupLibrary.createPopup(o, {
                  id: data.id,
                  ...extOptions,
                }),
                e.preventDefault(),
                !1
              );
            }
          }),
          data.type === "popup" &&
            data.lightbox &&
            new IntersectionObserver((t, o) => {
              t.forEach((r) => {
                r.isIntersecting && (o.unobserve(r.target), r.target.click());
              });
            }).observe(buttonElm));
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-qzrorzml: ", ex);
    }

    try {
      let argid = "beae-30a0f840block-image",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-30a0f840",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-30a0f840");
      args.el = args.els[0];
      ((M) => {
        var P;
        if (M.el) {
          if (M.shape) {
            const H = M.el.closest(".beae-slider-items");
            H &&
              !H.hasAttribute("data-svg") &&
              (H == null ||
                H.closest(".beae-section").insertAdjacentHTML(
                  "beforeend",
                  `
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${M.id}" clipPathUnits="objectBoundingBox">
                                ${M.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `,
                ),
              H.setAttribute("data-svg", "true"));
          }
          let O = M.el.querySelector(".beae-image-content-position"),
            I,
            z = window.innerWidth >= 768 && M.autoHover;
          var V = O.querySelector(".beae-img-ratio-control"),
            L = O.querySelector(".beae-img-comp-container"),
            T = O.querySelector(".beae-img-comp-container--second");
          if (V && T) {
            let H = function (A) {
              let R = 0,
                j;
              (D(),
                z
                  ? (O.onmouseover = function (Z) {
                      F(Z);
                    })
                  : (A.onmousedown = function (Z) {
                      F(Z);
                    }),
                (O.onmouseup = function () {
                  q();
                }),
                (A.ontouchstart = function (Z) {
                  F(Z);
                }),
                (O.ontouchend = function () {
                  q();
                }));
              function D() {
                (new ResizeObserver(() => {
                  window.requestAnimationFrame(() => {
                    I = T.offsetWidth;
                  });
                }).observe(T),
                  A.style.left && parseInt(A.style.left));
              }
              function F(Z) {
                ((check = !1),
                  Z.preventDefault(),
                  Z.clientX ? Z.clientX : Z.touches[0].clientX,
                  parseInt(A.style.left),
                  (R = 1),
                  (O.onmousemove = function (K) {
                    G(K);
                  }),
                  (O.ontouchmove = function (K) {
                    G(K);
                  }));
              }
              function q() {
                ((R = 0), (check = !0));
              }
              function G(Z) {
                if (R == 0) return !1;
                ((j = J(Z)), j < 0 && (j = 0), j > 100 && (j = 100), W(j));
              }
              function J(Z) {
                const K = O.getBoundingClientRect(),
                  le =
                    (Z.changedTouches
                      ? Z.changedTouches[0].clientX
                      : Z.clientX) - K.left;
                return Math.max(0, Math.min(100, Math.round((le * 100) / I)));
              }
              function W(Z) {
                ((A.style.left = Z + "%"),
                  (T.style.clipPath = `polygon(${Z}% 0%, ${Z}% 100%, 100% 100%, 100% 0)`),
                  (L.style.clipPath = `polygon(0% 100%, 0% 0%, ${Z}% 0%, ${Z}% 100%)`));
              }
            };
            (V && T && H(V),
              window.addEventListener("resize", function () {
                V &&
                  T &&
                  (new ResizeObserver(() => {
                    window.requestAnimationFrame(() => {
                      I = T.offsetWidth;
                    });
                  }).observe(T),
                  H(V));
              }));
          }
        }
        let N = (P = M.el) == null ? void 0 : P.querySelector("a.beae-x-image"),
          E = N == null ? void 0 : N.getAttribute("href");
        N &&
          M.mode.value !== "builder" &&
          E != null &&
          E.includes("#") &&
          N.addEventListener("click", (O) => {
            let I = document.querySelector(
              E + "," + (E == null ? void 0 : E.replace("#", ".")),
            );
            if (I)
              return (
                I.scrollIntoView({
                  behavior: "smooth",
                  block: "center",
                  inline: "center",
                }),
                O.preventDefault(),
                !1
              );
          });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-30a0f840: ", ex);
    }

    try {
      let argid = "beae-zhlac4fsblock-image",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-zhlac4fs",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-zhlac4fs");
      args.el = args.els[0];
      ((M) => {
        var P;
        if (M.el) {
          if (M.shape) {
            const H = M.el.closest(".beae-slider-items");
            H &&
              !H.hasAttribute("data-svg") &&
              (H == null ||
                H.closest(".beae-section").insertAdjacentHTML(
                  "beforeend",
                  `
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${M.id}" clipPathUnits="objectBoundingBox">
                                ${M.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `,
                ),
              H.setAttribute("data-svg", "true"));
          }
          let O = M.el.querySelector(".beae-image-content-position"),
            I,
            z = window.innerWidth >= 768 && M.autoHover;
          var V = O.querySelector(".beae-img-ratio-control"),
            L = O.querySelector(".beae-img-comp-container"),
            T = O.querySelector(".beae-img-comp-container--second");
          if (V && T) {
            let H = function (A) {
              let R = 0,
                j;
              (D(),
                z
                  ? (O.onmouseover = function (Z) {
                      F(Z);
                    })
                  : (A.onmousedown = function (Z) {
                      F(Z);
                    }),
                (O.onmouseup = function () {
                  q();
                }),
                (A.ontouchstart = function (Z) {
                  F(Z);
                }),
                (O.ontouchend = function () {
                  q();
                }));
              function D() {
                (new ResizeObserver(() => {
                  window.requestAnimationFrame(() => {
                    I = T.offsetWidth;
                  });
                }).observe(T),
                  A.style.left && parseInt(A.style.left));
              }
              function F(Z) {
                ((check = !1),
                  Z.preventDefault(),
                  Z.clientX ? Z.clientX : Z.touches[0].clientX,
                  parseInt(A.style.left),
                  (R = 1),
                  (O.onmousemove = function (K) {
                    G(K);
                  }),
                  (O.ontouchmove = function (K) {
                    G(K);
                  }));
              }
              function q() {
                ((R = 0), (check = !0));
              }
              function G(Z) {
                if (R == 0) return !1;
                ((j = J(Z)), j < 0 && (j = 0), j > 100 && (j = 100), W(j));
              }
              function J(Z) {
                const K = O.getBoundingClientRect(),
                  le =
                    (Z.changedTouches
                      ? Z.changedTouches[0].clientX
                      : Z.clientX) - K.left;
                return Math.max(0, Math.min(100, Math.round((le * 100) / I)));
              }
              function W(Z) {
                ((A.style.left = Z + "%"),
                  (T.style.clipPath = `polygon(${Z}% 0%, ${Z}% 100%, 100% 100%, 100% 0)`),
                  (L.style.clipPath = `polygon(0% 100%, 0% 0%, ${Z}% 0%, ${Z}% 100%)`));
              }
            };
            (V && T && H(V),
              window.addEventListener("resize", function () {
                V &&
                  T &&
                  (new ResizeObserver(() => {
                    window.requestAnimationFrame(() => {
                      I = T.offsetWidth;
                    });
                  }).observe(T),
                  H(V));
              }));
          }
        }
        let N = (P = M.el) == null ? void 0 : P.querySelector("a.beae-x-image"),
          E = N == null ? void 0 : N.getAttribute("href");
        N &&
          M.mode.value !== "builder" &&
          E != null &&
          E.includes("#") &&
          N.addEventListener("click", (O) => {
            let I = document.querySelector(
              E + "," + (E == null ? void 0 : E.replace("#", ".")),
            );
            if (I)
              return (
                I.scrollIntoView({
                  behavior: "smooth",
                  block: "center",
                  inline: "center",
                }),
                O.preventDefault(),
                !1
              );
          });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-zhlac4fs: ", ex);
    }

    try {
      let argid = "beae-8x76b9krblock-text",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-8x76b9kr",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-8x76b9kr");
      args.el = args.els[0];
      ((P) => {
        var I;
        let O =
          (I = P.el) == null ? void 0 : I.querySelectorAll(".beae-x-text a");
        O == null ||
          O.forEach((z) => {
            let H = z == null ? void 0 : z.getAttribute("href");
            z &&
              P.mode.value !== "builder" &&
              H != null &&
              H.includes("#") &&
              z.addEventListener("click", (A) => {
                let R = document.querySelector(
                  H + "," + (H == null ? void 0 : H.replace("#", ".")),
                );
                if (R)
                  return (
                    R.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                      inline: "center",
                    }),
                    A.preventDefault(),
                    !1
                  );
              });
          });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-8x76b9kr: ", ex);
    }

    try {
      let argid = "beae-435nbzpiblock-text",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-435nbzpi",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-435nbzpi");
      args.el = args.els[0];
      ((P) => {
        var I;
        let O =
          (I = P.el) == null ? void 0 : I.querySelectorAll(".beae-x-text a");
        O == null ||
          O.forEach((z) => {
            let H = z == null ? void 0 : z.getAttribute("href");
            z &&
              P.mode.value !== "builder" &&
              H != null &&
              H.includes("#") &&
              z.addEventListener("click", (A) => {
                let R = document.querySelector(
                  H + "," + (H == null ? void 0 : H.replace("#", ".")),
                );
                if (R)
                  return (
                    R.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                      inline: "center",
                    }),
                    A.preventDefault(),
                    !1
                  );
              });
          });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-435nbzpi: ", ex);
    }

    try {
      let argid = "beae-i5yitx6qbutton-js",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-i5yitx6q",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-i5yitx6q");
      args.el = args.els[0];
      ((data) => {
        let buttonElm = data.el.querySelector("a.beae-button-js");
        (buttonElm == null ||
          buttonElm.addEventListener("click", (e) => {
            var n, t;
            let extOptions = {};
            if (data.extendOptions)
              try {
                eval("extOptions = " + data.extendOptions);
              } catch (o) {
                ((extOptions = {}), console.error(o));
              }
            if (data.mode.value === "builder") return (e.preventDefault(), !1);
            let selector = e.currentTarget.getAttribute("href");
            if (selector.indexOf("#") === 0 && selector !== "#") {
              let o = document.querySelector(
                selector + "," + selector.replace("#", "."),
              );
              if (o)
                return (
                  o.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                    inline: "center",
                  }),
                  e.preventDefault(),
                  !1
                );
            }
            if (data.type === "popup") {
              if (window.isPreviewTemplate) {
                let l = data.el.querySelector(
                  ".beae-content-size-chart-preview",
                );
                (window.BeaePopupLibrary.createPopup(l, {
                  id: data.id,
                  ...extOptions,
                }),
                  e.preventDefault());
                return;
              }
              const o = window.createLoading(e.currentTarget);
              let r =
                (t = (n = window.BEAE_HELPER) == null ? void 0 : n.routes) ==
                null
                  ? void 0
                  : t.root_url;
              return (
                window.BeaePopupLibrary.lightbox({
                  id: data.id,
                  url:
                    (r !== "/" ? r : "") +
                    ((data == null ? void 0 : data.url) ?? "").replace(
                      "/popup/",
                      "/?view=beae-",
                    ),
                  ...extOptions,
                }).then((l) => {
                  (l.querySelector(".beae-product-form-next") &&
                    window.handleEventFormProductCard(l),
                    o.remove());
                }),
                e.preventDefault(),
                !1
              );
            } else if (data.type === "pages" && data.lightbox) {
              let o = data.pageContent
                .replace(/&lt;/g, "<")
                .replace(/&gt;/g, ">")
                .replace(/&amp;/g, "&")
                .replace(/&quot;/g, '"')
                .replace(/&#39;/g, "'");
              return (
                window.isPreviewTemplate &&
                  (o = data.el.querySelector(
                    ".beae-content-size-chart-preview",
                  )),
                window.BeaePopupLibrary.createPopup(o, {
                  id: data.id,
                  ...extOptions,
                }),
                e.preventDefault(),
                !1
              );
            }
          }),
          data.type === "popup" &&
            data.lightbox &&
            new IntersectionObserver((t, o) => {
              t.forEach((r) => {
                r.isIntersecting && (o.unobserve(r.target), r.target.click());
              });
            }).observe(buttonElm));
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-i5yitx6q: ", ex);
    }

    try {
      let argid = "beae-6ay8p2zmsection-js",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-6ay8p2zm",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-6ay8p2zm");
      args.el = args.els[0];
      ((t) => {
        var o;
        if (
          ((o = t.el.querySelector(".beae-grid-system")) == null ||
            o.addEventListener("scroll", (a) => {
              var r, l;
              let n = a.target;
              if (!n.classList.contains("beae-grid-carousel")) return;
              let s =
                Math.round(
                  (n.scrollLeft +
                    n.querySelector(".beae-grid-carousel__snaps").offsetLeft) /
                    (n.offsetWidth * 0.8),
                ) + 1;
              ((r = t.el.querySelector(
                ".beae-grid-carousel__pagination div.active",
              )) == null || r.classList.remove("active"),
                (l = t.el.querySelector(
                  '.beae-grid-carousel__pagination div[data-index="' + s + '"]',
                )) == null || l.classList.add("active"));
            }),
          t.mode.value == "live")
        ) {
          const a = t.el.querySelector(
              '.beae-section-background-video[data-device="desktop"]',
            ),
            n = t.el.querySelector(
              '.beae-section-background-video[data-device="mobile"]',
            ),
            s = [];
          (window.BEAEVIDEO &&
            window.BEAEVIDEO.convertBackgroundSection &&
            (window.innerWidth >= 768
              ? a &&
                window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo, a) &&
                s.push("desktop")
              : n &&
                window.BEAEVIDEO.convertBackgroundSection(
                  t.optionsVideoMobile,
                  n,
                ) &&
                s.push("mobile")),
            (a || n) &&
              window.addEventListener("resize", () => {
                if (
                  window.BEAEVIDEO &&
                  window.BEAEVIDEO.convertBackgroundSection
                ) {
                  if (!s.includes("desktop") && window.innerWidth >= 768 && a) {
                    const r = window.BEAEVIDEO.convertBackgroundSection(
                      t.optionsVideo,
                      a,
                    );
                    r && ((a.innerHTML = r.html), s.push("desktop"));
                  }
                  if (!s.includes("mobile") && window.innerWidth < 768 && n) {
                    const r = window.BEAEVIDEO.convertBackgroundSection(
                      t.optionsVideoMobile,
                      n,
                    );
                    r && ((n.innerHTML = r.html), s.push("mobile"));
                  }
                }
              }));
        }
        t.el.querySelectorAll(".beae-text-highlight").forEach((a) => {
          new IntersectionObserver(
            (s, r) => {
              s.forEach((l) => {
                l.isIntersecting &&
                  (l.target.querySelectorAll("path, line").forEach((c) => {
                    c.style.strokeDasharray =
                      parseFloat(
                        c.getAttribute("data-dash-ratio") *
                          l.target.offsetWidth *
                          2,
                      ) + "px, 999999px";
                  }),
                  r.unobserve(l.target));
              });
            },
            { root: document, rootMargin: "0px 0px -40%" },
          ).observe(a);
        });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-6ay8p2zm: ", ex);
    }

    try {
      let argid = "beae-7j2uzg6ublock-text",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-7j2uzg6u",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-7j2uzg6u");
      args.el = args.els[0];
      ((P) => {
        var I;
        let O =
          (I = P.el) == null ? void 0 : I.querySelectorAll(".beae-x-text a");
        O == null ||
          O.forEach((z) => {
            let H = z == null ? void 0 : z.getAttribute("href");
            z &&
              P.mode.value !== "builder" &&
              H != null &&
              H.includes("#") &&
              z.addEventListener("click", (A) => {
                let R = document.querySelector(
                  H + "," + (H == null ? void 0 : H.replace("#", ".")),
                );
                if (R)
                  return (
                    R.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                      inline: "center",
                    }),
                    A.preventDefault(),
                    !1
                  );
              });
          });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-7j2uzg6u: ", ex);
    }

    try {
      let argid = "beae-s9co1jd0block-text",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-s9co1jd0",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-s9co1jd0");
      args.el = args.els[0];
      ((P) => {
        var I;
        let O =
          (I = P.el) == null ? void 0 : I.querySelectorAll(".beae-x-text a");
        O == null ||
          O.forEach((z) => {
            let H = z == null ? void 0 : z.getAttribute("href");
            z &&
              P.mode.value !== "builder" &&
              H != null &&
              H.includes("#") &&
              z.addEventListener("click", (A) => {
                let R = document.querySelector(
                  H + "," + (H == null ? void 0 : H.replace("#", ".")),
                );
                if (R)
                  return (
                    R.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                      inline: "center",
                    }),
                    A.preventDefault(),
                    !1
                  );
              });
          });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-s9co1jd0: ", ex);
    }

    try {
      let argid = "beae-t6nse7q8section-js",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-t6nse7q8",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-t6nse7q8");
      args.el = args.els[0];
      ((t) => {
        var o;
        if (
          ((o = t.el.querySelector(".beae-grid-system")) == null ||
            o.addEventListener("scroll", (a) => {
              var r, l;
              let n = a.target;
              if (!n.classList.contains("beae-grid-carousel")) return;
              let s =
                Math.round(
                  (n.scrollLeft +
                    n.querySelector(".beae-grid-carousel__snaps").offsetLeft) /
                    (n.offsetWidth * 0.8),
                ) + 1;
              ((r = t.el.querySelector(
                ".beae-grid-carousel__pagination div.active",
              )) == null || r.classList.remove("active"),
                (l = t.el.querySelector(
                  '.beae-grid-carousel__pagination div[data-index="' + s + '"]',
                )) == null || l.classList.add("active"));
            }),
          t.mode.value == "live")
        ) {
          const a = t.el.querySelector(
              '.beae-section-background-video[data-device="desktop"]',
            ),
            n = t.el.querySelector(
              '.beae-section-background-video[data-device="mobile"]',
            ),
            s = [];
          (window.BEAEVIDEO &&
            window.BEAEVIDEO.convertBackgroundSection &&
            (window.innerWidth >= 768
              ? a &&
                window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo, a) &&
                s.push("desktop")
              : n &&
                window.BEAEVIDEO.convertBackgroundSection(
                  t.optionsVideoMobile,
                  n,
                ) &&
                s.push("mobile")),
            (a || n) &&
              window.addEventListener("resize", () => {
                if (
                  window.BEAEVIDEO &&
                  window.BEAEVIDEO.convertBackgroundSection
                ) {
                  if (!s.includes("desktop") && window.innerWidth >= 768 && a) {
                    const r = window.BEAEVIDEO.convertBackgroundSection(
                      t.optionsVideo,
                      a,
                    );
                    r && ((a.innerHTML = r.html), s.push("desktop"));
                  }
                  if (!s.includes("mobile") && window.innerWidth < 768 && n) {
                    const r = window.BEAEVIDEO.convertBackgroundSection(
                      t.optionsVideoMobile,
                      n,
                    );
                    r && ((n.innerHTML = r.html), s.push("mobile"));
                  }
                }
              }));
        }
        t.el.querySelectorAll(".beae-text-highlight").forEach((a) => {
          new IntersectionObserver(
            (s, r) => {
              s.forEach((l) => {
                l.isIntersecting &&
                  (l.target.querySelectorAll("path, line").forEach((c) => {
                    c.style.strokeDasharray =
                      parseFloat(
                        c.getAttribute("data-dash-ratio") *
                          l.target.offsetWidth *
                          2,
                      ) + "px, 999999px";
                  }),
                  r.unobserve(l.target));
              });
            },
            { root: document, rootMargin: "0px 0px -40%" },
          ).observe(a);
        });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-t6nse7q8: ", ex);
    }

    try {
      let argid = "beae-wpbo7na5block-tabs",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-wpbo7na5",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-wpbo7na5");
      args.el = args.els[0];
      ((data) => {
        const prefixClass = `div[data-id=${data.id}] > .beae-tab-wrp`;
        let tabs = data.el.querySelectorAll(
            `${prefixClass} > .beae-tab-items > .beae-tab-item`,
          ),
          contents = data.el.querySelectorAll(
            `${prefixClass} > .beae-tab-contents > .beae-tab-content`,
          ),
          rightside = data.el.querySelectorAll(
            `${prefixClass} .beae-rightside`,
          ),
          accordions = data.el.querySelectorAll(
            `${prefixClass} > .beae-tab-contents > .beae-tab-content > .beae-accordion-title--mobile`,
          ),
          activeTab =
            window.outerWidth && window.outerWidth <= 768
              ? data.activeTabMobile
              : data.activeTab,
          toggleImg = data.toggleImg,
          layout = data.layout,
          accordionMode = data.accordionMode;
        function resetActive() {
          (tabs.forEach((f) => f.classList.remove("active")),
            contents.forEach((f) => f.classList.remove("active")),
            accordions.forEach((f) => f.classList.remove("active")),
            toggleImg && rightside.forEach((f) => f.classList.remove("active")),
            contents.forEach((f) => {
              const b = f.querySelector(".beae-accordion-body").style;
              layout == "accordions"
                ? (b.maxHeight = "0px")
                : ((b.transform = "scaleY(0)"), (b.opacity = "0"));
            }));
        }
        function setActive(f) {
          (tabs[f].classList.add("active"),
            contents[f].classList.add("active"),
            accordions[f].classList.add("active"),
            toggleImg && rightside[f].classList.add("active"));
          const b = contents[f].querySelector(".beae-accordion-body");
          if (b) {
            const k = b.style;
            layout == "accordions"
              ? (k.maxHeight =
                  data.mode.value == "builder" ? "" : b.scrollHeight + "px")
              : ((k.transform = "scaleY(1)"),
                (k.transformOrigin = "top center"),
                (k.opacity = "1"));
          }
        }
        function removeActive(f) {
          (tabs[f].classList.remove("active"),
            contents[f].classList.remove("active"),
            accordions[f].classList.remove("active"),
            toggleImg && rightside[f].classList.remove("active"));
          const b = contents[f].querySelector(".beae-accordion-body").style;
          layout == "accordions"
            ? (b.maxHeight = "0px")
            : ((b.transform = "scaleY(0)"), (b.opacity = "0"));
        }
        (resetActive(),
          activeTab !== "none" &&
            accordionMode != "popup" &&
            setActive(activeTab),
          tabs.forEach((f, b) => {
            f.addEventListener("click", () => {
              (resetActive(), setActive(b));
            });
          }));
        const section = data.el.closest("section.beae-section");
        let sectionId = "";
        section && (sectionId = section.getAttribute("data-sectionid"));
        let extOptions = {};
        if (data.extendOptions)
          try {
            eval("extOptions = " + data.extendOptions);
          } catch (f) {
            ((extOptions = {}), console.error(f));
          }
        if (
          (accordions.forEach((f, b) => {
            f.addEventListener("click", () => {
              if (accordionMode == "popup" && data.mode.value != "builder") {
                const k = f.closest(".beae-tab-content");
                if (k) {
                  let m = document.createElement("div");
                  ((m.innerHTML = `
                            <h3 class="beae-popup__content-title">${f.querySelector("span").innerHTML}</h3>
                            <div class="beae-popup__content-body ${data.id}">${k.querySelector(".beae-accordion-body").innerHTML}</div>
                            `),
                    window.BeaePopupLibrary.createPopup(m, {
                      layout: extOptions.layout ? extOptions.layout : "right",
                      width: extOptions.width ? extOptions.width : "400px",
                      layoutMobile: extOptions.layoutMobile
                        ? extOptions.layoutMobile
                        : "bottom",
                      sectionId,
                    }));
                }
              } else
                accordionMode == "single"
                  ? (resetActive(), setActive(b))
                  : f.classList.contains("active")
                    ? removeActive(b)
                    : setActive(b);
            });
          }),
          layout == "tabs")
        ) {
          const f = data.el.querySelector(".beae-tab-contents"),
            b = f.querySelectorAll(".beae-tab-content-wrp");
          let k = 0,
            m = -1;
          (b.forEach((S, B) => {
            const w = S.offsetHeight;
            w > k && ((m = B), (k = w));
          }),
            new ResizeObserver(() => {
              f.style.setProperty(
                "--beae-tabs-max-height",
                `${b[m].offsetHeight}px`,
              );
            }).observe(b[m]));
        }
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-wpbo7na5: ", ex);
    }

    try {
      let argid = "beae-y0o88tg3block-text",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-y0o88tg3",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-y0o88tg3");
      args.el = args.els[0];
      ((P) => {
        var I;
        let O =
          (I = P.el) == null ? void 0 : I.querySelectorAll(".beae-x-text a");
        O == null ||
          O.forEach((z) => {
            let H = z == null ? void 0 : z.getAttribute("href");
            z &&
              P.mode.value !== "builder" &&
              H != null &&
              H.includes("#") &&
              z.addEventListener("click", (A) => {
                let R = document.querySelector(
                  H + "," + (H == null ? void 0 : H.replace("#", ".")),
                );
                if (R)
                  return (
                    R.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                      inline: "center",
                    }),
                    A.preventDefault(),
                    !1
                  );
              });
          });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-y0o88tg3: ", ex);
    }

    try {
      let argid = "beae-x389o912block-text",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-x389o912",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-x389o912");
      args.el = args.els[0];
      ((P) => {
        var I;
        let O =
          (I = P.el) == null ? void 0 : I.querySelectorAll(".beae-x-text a");
        O == null ||
          O.forEach((z) => {
            let H = z == null ? void 0 : z.getAttribute("href");
            z &&
              P.mode.value !== "builder" &&
              H != null &&
              H.includes("#") &&
              z.addEventListener("click", (A) => {
                let R = document.querySelector(
                  H + "," + (H == null ? void 0 : H.replace("#", ".")),
                );
                if (R)
                  return (
                    R.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                      inline: "center",
                    }),
                    A.preventDefault(),
                    !1
                  );
              });
          });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-x389o912: ", ex);
    }

    try {
      let argid = "beae-l48qxrysblock-text",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-l48qxrys",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-l48qxrys");
      args.el = args.els[0];
      ((P) => {
        var I;
        let O =
          (I = P.el) == null ? void 0 : I.querySelectorAll(".beae-x-text a");
        O == null ||
          O.forEach((z) => {
            let H = z == null ? void 0 : z.getAttribute("href");
            z &&
              P.mode.value !== "builder" &&
              H != null &&
              H.includes("#") &&
              z.addEventListener("click", (A) => {
                let R = document.querySelector(
                  H + "," + (H == null ? void 0 : H.replace("#", ".")),
                );
                if (R)
                  return (
                    R.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                      inline: "center",
                    }),
                    A.preventDefault(),
                    !1
                  );
              });
          });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-l48qxrys: ", ex);
    }

    try {
      let argid = "beae-6q23kpvmsection-js",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-6q23kpvm",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-6q23kpvm");
      args.el = args.els[0];
      ((t) => {
        var o;
        if (
          ((o = t.el.querySelector(".beae-grid-system")) == null ||
            o.addEventListener("scroll", (a) => {
              var r, l;
              let n = a.target;
              if (!n.classList.contains("beae-grid-carousel")) return;
              let s =
                Math.round(
                  (n.scrollLeft +
                    n.querySelector(".beae-grid-carousel__snaps").offsetLeft) /
                    (n.offsetWidth * 0.8),
                ) + 1;
              ((r = t.el.querySelector(
                ".beae-grid-carousel__pagination div.active",
              )) == null || r.classList.remove("active"),
                (l = t.el.querySelector(
                  '.beae-grid-carousel__pagination div[data-index="' + s + '"]',
                )) == null || l.classList.add("active"));
            }),
          t.mode.value == "live")
        ) {
          const a = t.el.querySelector(
              '.beae-section-background-video[data-device="desktop"]',
            ),
            n = t.el.querySelector(
              '.beae-section-background-video[data-device="mobile"]',
            ),
            s = [];
          (window.BEAEVIDEO &&
            window.BEAEVIDEO.convertBackgroundSection &&
            (window.innerWidth >= 768
              ? a &&
                window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo, a) &&
                s.push("desktop")
              : n &&
                window.BEAEVIDEO.convertBackgroundSection(
                  t.optionsVideoMobile,
                  n,
                ) &&
                s.push("mobile")),
            (a || n) &&
              window.addEventListener("resize", () => {
                if (
                  window.BEAEVIDEO &&
                  window.BEAEVIDEO.convertBackgroundSection
                ) {
                  if (!s.includes("desktop") && window.innerWidth >= 768 && a) {
                    const r = window.BEAEVIDEO.convertBackgroundSection(
                      t.optionsVideo,
                      a,
                    );
                    r && ((a.innerHTML = r.html), s.push("desktop"));
                  }
                  if (!s.includes("mobile") && window.innerWidth < 768 && n) {
                    const r = window.BEAEVIDEO.convertBackgroundSection(
                      t.optionsVideoMobile,
                      n,
                    );
                    r && ((n.innerHTML = r.html), s.push("mobile"));
                  }
                }
              }));
        }
        t.el.querySelectorAll(".beae-text-highlight").forEach((a) => {
          new IntersectionObserver(
            (s, r) => {
              s.forEach((l) => {
                l.isIntersecting &&
                  (l.target.querySelectorAll("path, line").forEach((c) => {
                    c.style.strokeDasharray =
                      parseFloat(
                        c.getAttribute("data-dash-ratio") *
                          l.target.offsetWidth *
                          2,
                      ) + "px, 999999px";
                  }),
                  r.unobserve(l.target));
              });
            },
            { root: document, rootMargin: "0px 0px -40%" },
          ).observe(a);
        });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-6q23kpvm: ", ex);
    }

    try {
      let argid = "beae-nqnhp3tlblock-text",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-nqnhp3tl",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-nqnhp3tl");
      args.el = args.els[0];
      ((P) => {
        var I;
        let O =
          (I = P.el) == null ? void 0 : I.querySelectorAll(".beae-x-text a");
        O == null ||
          O.forEach((z) => {
            let H = z == null ? void 0 : z.getAttribute("href");
            z &&
              P.mode.value !== "builder" &&
              H != null &&
              H.includes("#") &&
              z.addEventListener("click", (A) => {
                let R = document.querySelector(
                  H + "," + (H == null ? void 0 : H.replace("#", ".")),
                );
                if (R)
                  return (
                    R.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                      inline: "center",
                    }),
                    A.preventDefault(),
                    !1
                  );
              });
          });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-nqnhp3tl: ", ex);
    }

    try {
      let argid = "beae-otf9qujhblock-text",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-otf9qujh",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-otf9qujh");
      args.el = args.els[0];
      ((P) => {
        var I;
        let O =
          (I = P.el) == null ? void 0 : I.querySelectorAll(".beae-x-text a");
        O == null ||
          O.forEach((z) => {
            let H = z == null ? void 0 : z.getAttribute("href");
            z &&
              P.mode.value !== "builder" &&
              H != null &&
              H.includes("#") &&
              z.addEventListener("click", (A) => {
                let R = document.querySelector(
                  H + "," + (H == null ? void 0 : H.replace("#", ".")),
                );
                if (R)
                  return (
                    R.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                      inline: "center",
                    }),
                    A.preventDefault(),
                    !1
                  );
              });
          });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-otf9qujh: ", ex);
    }

    try {
      let argid = "beae-es1k8y6dblock-text",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-es1k8y6d",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-es1k8y6d");
      args.el = args.els[0];
      ((P) => {
        var I;
        let O =
          (I = P.el) == null ? void 0 : I.querySelectorAll(".beae-x-text a");
        O == null ||
          O.forEach((z) => {
            let H = z == null ? void 0 : z.getAttribute("href");
            z &&
              P.mode.value !== "builder" &&
              H != null &&
              H.includes("#") &&
              z.addEventListener("click", (A) => {
                let R = document.querySelector(
                  H + "," + (H == null ? void 0 : H.replace("#", ".")),
                );
                if (R)
                  return (
                    R.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                      inline: "center",
                    }),
                    A.preventDefault(),
                    !1
                  );
              });
          });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-es1k8y6d: ", ex);
    }

    try {
      let argid = "beae-87mu7kxzsection-slide-show",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-87mu7kxz",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-87mu7kxz");
      args.el = args.els[0];
      ((g) => {
        window.BeaeSlider && !g.noRunJs && window.BeaeSlider(g);
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-87mu7kxz: ", ex);
    }

    try {
      let argid = "beae-wuxbocbvblock-textloop-0",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-wuxbocbv",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-wuxbocbv");
      args.el = args.els[0];
      ((P) => {
        var I;
        let O =
          (I = P.el) == null ? void 0 : I.querySelectorAll(".beae-x-text a");
        O == null ||
          O.forEach((z) => {
            let H = z == null ? void 0 : z.getAttribute("href");
            z &&
              P.mode.value !== "builder" &&
              H != null &&
              H.includes("#") &&
              z.addEventListener("click", (A) => {
                let R = document.querySelector(
                  H + "," + (H == null ? void 0 : H.replace("#", ".")),
                );
                if (R)
                  return (
                    R.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                      inline: "center",
                    }),
                    A.preventDefault(),
                    !1
                  );
              });
          });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-wuxbocbv: ", ex);
    }

    try {
      let argid = "beae-wuxbocbvblock-textloop-1",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-wuxbocbv",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-wuxbocbv");
      args.el = args.els[1];
      ((P) => {
        var I;
        let O =
          (I = P.el) == null ? void 0 : I.querySelectorAll(".beae-x-text a");
        O == null ||
          O.forEach((z) => {
            let H = z == null ? void 0 : z.getAttribute("href");
            z &&
              P.mode.value !== "builder" &&
              H != null &&
              H.includes("#") &&
              z.addEventListener("click", (A) => {
                let R = document.querySelector(
                  H + "," + (H == null ? void 0 : H.replace("#", ".")),
                );
                if (R)
                  return (
                    R.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                      inline: "center",
                    }),
                    A.preventDefault(),
                    !1
                  );
              });
          });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-wuxbocbv: ", ex);
    }

    try {
      let argid = "beae-wuxbocbvblock-textloop-2",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-wuxbocbv",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-wuxbocbv");
      args.el = args.els[2];
      ((P) => {
        var I;
        let O =
          (I = P.el) == null ? void 0 : I.querySelectorAll(".beae-x-text a");
        O == null ||
          O.forEach((z) => {
            let H = z == null ? void 0 : z.getAttribute("href");
            z &&
              P.mode.value !== "builder" &&
              H != null &&
              H.includes("#") &&
              z.addEventListener("click", (A) => {
                let R = document.querySelector(
                  H + "," + (H == null ? void 0 : H.replace("#", ".")),
                );
                if (R)
                  return (
                    R.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                      inline: "center",
                    }),
                    A.preventDefault(),
                    !1
                  );
              });
          });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-wuxbocbv: ", ex);
    }

    try {
      let argid = "beae-wuxbocbvblock-textloop-3",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-wuxbocbv",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-wuxbocbv");
      args.el = args.els[3];
      ((P) => {
        var I;
        let O =
          (I = P.el) == null ? void 0 : I.querySelectorAll(".beae-x-text a");
        O == null ||
          O.forEach((z) => {
            let H = z == null ? void 0 : z.getAttribute("href");
            z &&
              P.mode.value !== "builder" &&
              H != null &&
              H.includes("#") &&
              z.addEventListener("click", (A) => {
                let R = document.querySelector(
                  H + "," + (H == null ? void 0 : H.replace("#", ".")),
                );
                if (R)
                  return (
                    R.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                      inline: "center",
                    }),
                    A.preventDefault(),
                    !1
                  );
              });
          });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-wuxbocbv: ", ex);
    }

    try {
      let argid = "beae-wuxbocbvblock-textloop-4",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-wuxbocbv",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-wuxbocbv");
      args.el = args.els[4];
      ((P) => {
        var I;
        let O =
          (I = P.el) == null ? void 0 : I.querySelectorAll(".beae-x-text a");
        O == null ||
          O.forEach((z) => {
            let H = z == null ? void 0 : z.getAttribute("href");
            z &&
              P.mode.value !== "builder" &&
              H != null &&
              H.includes("#") &&
              z.addEventListener("click", (A) => {
                let R = document.querySelector(
                  H + "," + (H == null ? void 0 : H.replace("#", ".")),
                );
                if (R)
                  return (
                    R.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                      inline: "center",
                    }),
                    A.preventDefault(),
                    !1
                  );
              });
          });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-wuxbocbv: ", ex);
    }

    try {
      let argid = "beae-wuxbocbvblock-textloop-5",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-wuxbocbv",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-wuxbocbv");
      args.el = args.els[5];
      ((P) => {
        var I;
        let O =
          (I = P.el) == null ? void 0 : I.querySelectorAll(".beae-x-text a");
        O == null ||
          O.forEach((z) => {
            let H = z == null ? void 0 : z.getAttribute("href");
            z &&
              P.mode.value !== "builder" &&
              H != null &&
              H.includes("#") &&
              z.addEventListener("click", (A) => {
                let R = document.querySelector(
                  H + "," + (H == null ? void 0 : H.replace("#", ".")),
                );
                if (R)
                  return (
                    R.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                      inline: "center",
                    }),
                    A.preventDefault(),
                    !1
                  );
              });
          });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-wuxbocbv: ", ex);
    }

    try {
      let argid = "beae-wuxbocbvblock-textloop-6",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-wuxbocbv",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-wuxbocbv");
      args.el = args.els[6];
      ((P) => {
        var I;
        let O =
          (I = P.el) == null ? void 0 : I.querySelectorAll(".beae-x-text a");
        O == null ||
          O.forEach((z) => {
            let H = z == null ? void 0 : z.getAttribute("href");
            z &&
              P.mode.value !== "builder" &&
              H != null &&
              H.includes("#") &&
              z.addEventListener("click", (A) => {
                let R = document.querySelector(
                  H + "," + (H == null ? void 0 : H.replace("#", ".")),
                );
                if (R)
                  return (
                    R.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                      inline: "center",
                    }),
                    A.preventDefault(),
                    !1
                  );
              });
          });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-wuxbocbv: ", ex);
    }

    try {
      let argid = "beae-gn49zxhjblock-text",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-gn49zxhj",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-gn49zxhj");
      args.el = args.els[0];
      ((P) => {
        var I;
        let O =
          (I = P.el) == null ? void 0 : I.querySelectorAll(".beae-x-text a");
        O == null ||
          O.forEach((z) => {
            let H = z == null ? void 0 : z.getAttribute("href");
            z &&
              P.mode.value !== "builder" &&
              H != null &&
              H.includes("#") &&
              z.addEventListener("click", (A) => {
                let R = document.querySelector(
                  H + "," + (H == null ? void 0 : H.replace("#", ".")),
                );
                if (R)
                  return (
                    R.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                      inline: "center",
                    }),
                    A.preventDefault(),
                    !1
                  );
              });
          });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-gn49zxhj: ", ex);
    }

    try {
      let argid = "beae-d4pjszhqsection-slide-show",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-d4pjszhq",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-d4pjszhq");
      args.el = args.els[0];
      ((g) => {
        window.BeaeSlider && !g.noRunJs && window.BeaeSlider(g);
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-d4pjszhq: ", ex);
    }

    try {
      let argid = "beae-b6ebpxaoblock-textloop-0",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-b6ebpxao",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-b6ebpxao");
      args.el = args.els[0];
      ((P) => {
        var I;
        let O =
          (I = P.el) == null ? void 0 : I.querySelectorAll(".beae-x-text a");
        O == null ||
          O.forEach((z) => {
            let H = z == null ? void 0 : z.getAttribute("href");
            z &&
              P.mode.value !== "builder" &&
              H != null &&
              H.includes("#") &&
              z.addEventListener("click", (A) => {
                let R = document.querySelector(
                  H + "," + (H == null ? void 0 : H.replace("#", ".")),
                );
                if (R)
                  return (
                    R.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                      inline: "center",
                    }),
                    A.preventDefault(),
                    !1
                  );
              });
          });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-b6ebpxao: ", ex);
    }

    try {
      let argid = "beae-b6ebpxaoblock-textloop-1",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-b6ebpxao",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-b6ebpxao");
      args.el = args.els[1];
      ((P) => {
        var I;
        let O =
          (I = P.el) == null ? void 0 : I.querySelectorAll(".beae-x-text a");
        O == null ||
          O.forEach((z) => {
            let H = z == null ? void 0 : z.getAttribute("href");
            z &&
              P.mode.value !== "builder" &&
              H != null &&
              H.includes("#") &&
              z.addEventListener("click", (A) => {
                let R = document.querySelector(
                  H + "," + (H == null ? void 0 : H.replace("#", ".")),
                );
                if (R)
                  return (
                    R.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                      inline: "center",
                    }),
                    A.preventDefault(),
                    !1
                  );
              });
          });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-b6ebpxao: ", ex);
    }

    try {
      let argid = "beae-b6ebpxaoblock-textloop-2",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-b6ebpxao",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-b6ebpxao");
      args.el = args.els[2];
      ((P) => {
        var I;
        let O =
          (I = P.el) == null ? void 0 : I.querySelectorAll(".beae-x-text a");
        O == null ||
          O.forEach((z) => {
            let H = z == null ? void 0 : z.getAttribute("href");
            z &&
              P.mode.value !== "builder" &&
              H != null &&
              H.includes("#") &&
              z.addEventListener("click", (A) => {
                let R = document.querySelector(
                  H + "," + (H == null ? void 0 : H.replace("#", ".")),
                );
                if (R)
                  return (
                    R.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                      inline: "center",
                    }),
                    A.preventDefault(),
                    !1
                  );
              });
          });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-b6ebpxao: ", ex);
    }

    try {
      let argid = "beae-b6ebpxaoblock-textloop-3",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-b6ebpxao",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-b6ebpxao");
      args.el = args.els[3];
      ((P) => {
        var I;
        let O =
          (I = P.el) == null ? void 0 : I.querySelectorAll(".beae-x-text a");
        O == null ||
          O.forEach((z) => {
            let H = z == null ? void 0 : z.getAttribute("href");
            z &&
              P.mode.value !== "builder" &&
              H != null &&
              H.includes("#") &&
              z.addEventListener("click", (A) => {
                let R = document.querySelector(
                  H + "," + (H == null ? void 0 : H.replace("#", ".")),
                );
                if (R)
                  return (
                    R.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                      inline: "center",
                    }),
                    A.preventDefault(),
                    !1
                  );
              });
          });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-b6ebpxao: ", ex);
    }

    try {
      let argid = "beae-b6ebpxaoblock-textloop-4",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-b6ebpxao",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-b6ebpxao");
      args.el = args.els[4];
      ((P) => {
        var I;
        let O =
          (I = P.el) == null ? void 0 : I.querySelectorAll(".beae-x-text a");
        O == null ||
          O.forEach((z) => {
            let H = z == null ? void 0 : z.getAttribute("href");
            z &&
              P.mode.value !== "builder" &&
              H != null &&
              H.includes("#") &&
              z.addEventListener("click", (A) => {
                let R = document.querySelector(
                  H + "," + (H == null ? void 0 : H.replace("#", ".")),
                );
                if (R)
                  return (
                    R.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                      inline: "center",
                    }),
                    A.preventDefault(),
                    !1
                  );
              });
          });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-b6ebpxao: ", ex);
    }

    try {
      let argid = "beae-b6ebpxaoblock-textloop-5",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-b6ebpxao",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-b6ebpxao");
      args.el = args.els[5];
      ((P) => {
        var I;
        let O =
          (I = P.el) == null ? void 0 : I.querySelectorAll(".beae-x-text a");
        O == null ||
          O.forEach((z) => {
            let H = z == null ? void 0 : z.getAttribute("href");
            z &&
              P.mode.value !== "builder" &&
              H != null &&
              H.includes("#") &&
              z.addEventListener("click", (A) => {
                let R = document.querySelector(
                  H + "," + (H == null ? void 0 : H.replace("#", ".")),
                );
                if (R)
                  return (
                    R.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                      inline: "center",
                    }),
                    A.preventDefault(),
                    !1
                  );
              });
          });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-b6ebpxao: ", ex);
    }

    try {
      let argid = "beae-b6ebpxaoblock-textloop-6",
        args = window.BEAEARGS[argid];
      if (!args) {
        args = {
          id: "beae-b6ebpxao",
          mode: { value: "live" },
        };
      }
      args.els = document.querySelectorAll(".beae-b6ebpxao");
      args.el = args.els[6];
      ((P) => {
        var I;
        let O =
          (I = P.el) == null ? void 0 : I.querySelectorAll(".beae-x-text a");
        O == null ||
          O.forEach((z) => {
            let H = z == null ? void 0 : z.getAttribute("href");
            z &&
              P.mode.value !== "builder" &&
              H != null &&
              H.includes("#") &&
              z.addEventListener("click", (A) => {
                let R = document.querySelector(
                  H + "," + (H == null ? void 0 : H.replace("#", ".")),
                );
                if (R)
                  return (
                    R.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                      inline: "center",
                    }),
                    A.preventDefault(),
                    !1
                  );
              });
          });
      })(args);
    } catch (ex) {
      console.error("BEAE JS ERROR ID beae-b6ebpxao: ", ex);
    }
  };
  if (window.BEAEBASE) {
    js_OAFKA6MH();
  } else {
    window.BEAEPAGEJS.push(js_OAFKA6MH);
  }
})();
